<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
      </toolbar>
      <!-- 新增所属机构显示 -->
      <div style="margin: 10px 0; color: var(--btn-primary, #2563eb); display:flex; align-items:center; flex-wrap:wrap; gap:12px;">
        <span>所属机构：</span>
        <span>{{ currentDepartmentName || '全部' }}</span>
        <el-radio-group v-model="viewMode" size="mini" @change="onViewModeChange">
          <el-radio-button label="week">周次查看</el-radio-button>
          <el-radio-button label="template">模板编辑</el-radio-button>
        </el-radio-group>
        <template v-if="viewMode === 'week'">
          <el-button size="mini" icon="el-icon-arrow-left" :disabled="!canPrevWeek" @click="shiftWeek(-1)"></el-button>
          <el-select v-model="selectedWeekNumber" size="mini" style="width:280px" placeholder="选择周次" @change="onWeekChange">
            <el-option
              v-for="w in semesterWeeks"
              :key="w.WeekNumber"
              :label="formatWeekOption(w)"
              :value="w.WeekNumber">
            </el-option>
          </el-select>
          <el-button size="mini" icon="el-icon-arrow-right" :disabled="!canNextWeek" @click="shiftWeek(1)"></el-button>
        </template>
      </div>
      <!-- 列表改为按班级/部门分组显示周课表 -->
      <div v-if="listLoading" style="text-align:center; padding: 40px 0">加载中...</div>
      <div v-else class="timetable-container">
        <div v-if="viewMode === 'week'">
          <div v-if="!DepartmentId" class="empty-tip" style="padding:40px; color:#999; text-align:center;">
            <div style="font-size:16px; color:#606266;">请选择具体班级后查看周课表</div>
          </div>
          <div v-else-if="weekPeriods.length === 0" class="empty-tip" style="padding:40px; color:#999; text-align:center;">
            <div style="font-size:16px; color:#606266;">本周暂无课程</div>
          </div>
          <div v-else class="timetable-card">
            <table class="timetable">
              <thead>
                <tr>
                  <th class="period-head">节次/时间</th>
                  <th v-for="d in weekDayHeaders" :key="d.weekDay"
                    :class="{ 'today-col': d.isToday }">
                    <div>周{{ d.weekLabel }} {{ d.dateLabel }}</div>
                    <div v-if="d.ruleLabel" class="day-rule-tag">{{ d.ruleLabel }}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="period in weekPeriods" :key="'w-' + period.classNo">
                  <td class="period-cell">
                    <div>{{ period.periodName || ('第' + period.classNo + '节') }}</div>
                    <div class="time" v-if="period.startTime">{{ period.startTime }}-{{ period.endTime }}</div>
                  </td>
                  <td v-for="d in weekDayHeaders" :key="d.weekDay" class="cell" :class="{ 'today-col': d.isToday, 'rest-col': d.isRest }">
                    <div class="cell-content" v-if="getWeekCell(period.classNo, d.weekDay)">
                      <div class="course-name">{{ getWeekCell(period.classNo, d.weekDay).courseName }}</div>
                      <div class="teacher-name">{{ getWeekCell(period.classNo, d.weekDay).teacherName }}</div>
                      <div v-if="getWeekCell(period.classNo, d.weekDay).adjLabel" class="adj-badge">{{ getWeekCell(period.classNo, d.weekDay).adjLabel }}</div>
                    </div>
                    <div v-else-if="d.isRest" class="rest-text">放假</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <template v-else>
        <div v-if="timetableGroups.length === 0" class="empty-tip" style="padding:40px; color:#999; text-align:center;">
          <div style="font-size:20px; margin-bottom:12px; color:#606266; font-weight:600">暂无数据</div>
        </div>
        <div v-for="group in timetableGroups" :key="group.title" class="timetable-card">

          <table class="timetable">
            <thead>
              <tr>
                <th style="width:50px"></th>
                <th class="period-head">节次/时间</th>
                <th v-for="d in 7" :key="d">周{{ ['一', '二', '三', '四', '五', '六', '日'][d - 1] }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="period in group.periods" :key="period.ClassNo + '-' + period.Id"
                :class="{ selected: currentRow && currentRow.Id === period.Id }" @click="selectCurrentRow(period)">
                <td class="select-cell">
                  <input type="checkbox" :checked="currentRow && currentRow.Id === period.Id"
                    @change.stop="selectCurrentRow(period)" />
                </td>
                <td class="period-cell">
                  <div>{{ period.PeriodName || ('第' + period.ClassNo + '节') }}</div>
                  <div class="time">{{ formatScheduleTime(period) }}</div>
                </td>
                <td v-for="day in 7" :key="day" class="cell" @click.stop="handleCellClick(period, day)">
                  <div class="cell-content">

                    <!-- 1. 代调课层已移除，改由“查看近期变动”按钮统一拉取展示 -->

                    <!-- 2. 原课程层 -->
                    <div class="original-info">

                      <!-- 课程名：支持 split 显示 (兼容中英文斜杠) -->
                      <div class="course-name"
                        v-if="period['W' + day + 'CourseName'] && period['W' + day + 'CourseName'] !== '/'">
                        <template
                          v-if="period['W' + day + 'CourseName'].includes('/') || period['W' + day + 'CourseName'].includes('／')">
                          <span>{{ period['W' + day + 'CourseName'].split(/\/|／/)[0] }}</span>
                          <span class="sep">/</span>
                          <span>{{ period['W' + day + 'CourseName'].split(/\/|／/)[1] }}</span>
                        </template>
                        <template v-else>
                          <span>{{ period['W' + day + 'CourseName'] }}</span>
                        </template>
                      </div>

                      <!-- 教师名：支持 split 显示 -->
                      <div class="teacher-name" v-if="getTeachersDisplay(period, day).length">
                        <template v-if="getTeachersDisplay(period, day).length > 1">
                          <span>{{ getTeachersDisplay(period, day)[0] }}</span>
                          <span class="sep"> / </span>
                          <span>{{ getTeachersDisplay(period, day)[1] }}</span>
                        </template>
                        <template v-else>
                          <span>{{ getTeachersDisplay(period, day).join(' / ') }}</span>
                        </template>
                      </div>

                      <div class="room-name" v-if="quickEditShowRoom && getRoomDisplay(period, day)">
                        {{ getRoomDisplay(period, day) }}
                      </div>
                    </div>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        </template>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar" v-if="total > 0 && viewMode === 'template'">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!-- 全班级调代课变动记录弹窗 -->
      <el-dialog title="班级课表变动记录 (近30天)" :visible.sync="adjRecordVisible" width="600px" append-to-body>
        <div class="adj-record-list" v-loading="adjRecordLoading">
          <div v-if="!adjRecordLoading && adjRecordTotal === 0" class="adj-record-empty">
            暂无变动记录
          </div>
          <el-timeline v-else-if="allClassAdjustments.length > 0">
            <el-timeline-item v-for="(item, index) in allClassAdjustments" :key="index" :timestamp="item.date"
              :type="item.date < todayStr ? '' : 'primary'" placement="top">
              <el-card shadow="hover"
                :style="{ borderLeft: item.type.includes('代') ? '4px solid #67C23A' : '4px solid #E6A23C' }">
                <div style="display:flex; justify-content: space-between; align-items: center;">
                  <b style="font-size: 15px;">{{ item.type }} - {{ item.targetAdjustDate }} {{ item.periodName }}</b>
                  <el-tag size="mini" :type="item.date < todayStr ? 'info' : 'success'">
                    {{ item.date < todayStr ? '已过期' : '待生效' }} </el-tag>
                </div>
                <div
                  style="margin-top: 10px; padding: 12px; background: #f8f9fb; border-radius: 6px; font-size: 13px; line-height: 1.6;">
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <div
                        style="background: #ffffff; border: 1px solid #e4e7ed; border-radius: 4px; padding: 10px; height: 100%;">
                        <div style="color: #909399; font-size: 12px; margin-bottom: 6px;">调整前 排课明细</div>
                        <div style="color: #606266; margin-bottom: 4px;"> <i class="el-icon-date"
                            style="color: #909399; margin-right: 4px;"></i>{{ item.originalDisplayDate }} {{
                              item.originalPeriod }}</div>
                        <div style="color: #909399; margin-bottom: 4px;"> <i class="el-icon-time"
                            style="margin-right: 4px;"></i>{{ item.originalTime }}</div>
                        <div style="color: #303133; display: flex; align-items: center;">
                          <i class="el-icon-reading" style="color:var(--btn-primary, #2563eb); margin-right: 4px;"></i> <span
                            style="font-weight: bold; margin-right: 6px;">{{ item.originalCourse }}</span>
                          <el-tag size="mini" type="info">{{ item.originalTeacher }}</el-tag>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="item.handleType === 1"
                        style="background: #fff8e6; border: 1px solid #f3d19e; border-radius: 4px; padding: 10px; height: 100%;">
                        <div style="color: #E6A23C; font-size: 12px; font-weight: bold; margin-bottom: 6px;">调整后 新排课
                        </div>
                        <div style="color: #E6A23C; margin-bottom: 4px;"> <i class="el-icon-date"
                            style="margin-right: 4px;"></i>{{ item.newDisplayDate }} {{ item.newPeriod }}</div>
                        <div style="color: #E6A23C; margin-bottom: 4px;"> <i class="el-icon-time"
                            style="margin-right: 4px;"></i>{{ item.newTime }}</div>
                        <div style="color: #E6A23C; display: flex; align-items: center;">
                          <i class="el-icon-reading" style="margin-right: 4px;"></i> <span
                            style="font-weight: bold; margin-right: 6px;">{{ item.course }}</span>
                          <el-tag size="mini" type="warning">{{ item.teacher }}</el-tag>
                        </div>
                      </div>
                      <div v-else
                        style="background: #f0f9eb; border: 1px solid #c2e7b0; border-radius: 4px; padding: 10px; height: 100%; display: flex; flex-direction: column; justify-content: center;">
                        <div style="color: #67C23A; margin-bottom: 4px;">
                          <i class="el-icon-reading" style="margin-right: 4px;"></i> <span style="font-weight: bold;">{{
                            item.course }}</span>
                        </div>
                        <div style="color: #67C23A;">
                          <i class="el-icon-user" style="margin-right: 4px;"></i> 由 <span style="font-weight: bold;">{{
                            item.teacher }}</span> 老师代课
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div v-if="adjRecordTotal > 0" class="adj-record-pager">
          <el-pagination @current-change="handleAdjRecordPageChange" @size-change="handleAdjRecordSizeChange"
            :current-page="adjRecordPage" :page-size="adjRecordPageSize" :page-sizes="[5, 10, 20]"
            :total="adjRecordTotal" layout="total, sizes, prev, pager, next"></el-pagination>
        </div>
        <div slot="footer">
          <el-button @click="adjRecordVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!--编辑界面-->
      <el-dialog title="编辑科目" width="60%" :visible.sync="editFormVisible" v-model="editFormVisible"
        :close-on-click-modal="false" v-loading="editDataLoading" @close="onEditDialogClose">
        <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">

          <el-form-item label="所属机构" prop="Dids">
            <el-input v-if="deptCascaderLocked" :value="lockedDepartmentName || currentDepartmentName" disabled style="width: 100%" />
            <el-cascader v-else placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids" :options="options"
              :show-all-levels="false" filterable :key="cascaderKey"
              :props="$deptCascaderProps" @change="handleEditClassChange"></el-cascader>
          </el-form-item>
          <el-form-item label="方案">
            <span style="color:var(--btn-primary, #2563eb)">{{ scheduleName || '未选择' }}</span>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="节次选择" prop="SchoolSchedulePeriodId">
                <el-select style="width:100%" v-model="editForm.SchoolSchedulePeriodId" placeholder="请选择节次"
                  @change="onSchedulePeriodChange('edit', $event)">
                  <el-option v-for="s in scheduleList" :key="getScheduleOptionKey(s)" :label="formatScheduleLabel(s)"
                    :value="getScheduleOptionValue(s)"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="课程开始时间:" prop="StartTime">
                <el-time-picker v-model="editForm.StartTime" placeholder="请选择开始时间" style="width: 100%;"
                  value-format="HH:mm" format="HH:mm" disabled></el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程结束时间:" prop="EndTime">
                <el-time-picker v-model="editForm.EndTime" placeholder="请选择结束时间" style="width: 100%;"
                  value-format="HH:mm" format="HH:mm" disabled></el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">

            <el-col :span="12">
              <el-form-item label="序号" prop="ClassNo">
                <el-input v-model="editForm.ClassNo" type="number" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提前考勤(分钟)" prop="EarlyEnterTime">
                <el-input v-model="editForm.EarlyEnterTime" type="number" min="0" placeholder="请输入提前考勤时间"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="周一课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="editForm.W1CourseId" class="course-select"
                @change="editForm.W1CourseId2 = $event; getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW1'); getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW1_2'); editForm.W1TeacherInfoId = null; editForm.W1TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="editForm.W1CourseId2" class="course-select"
                @change="getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW1_2'); editForm.W1TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="editForm.W1TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW1" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="editForm.W1TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW1_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="周二课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="editForm.W2CourseId" class="course-select"
                @change="editForm.W2CourseId2 = $event; getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW2'); getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW2_2'); editForm.W2TeacherInfoId = null; editForm.W2TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="editForm.W2CourseId2" class="course-select"
                @change="getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW2_2'); editForm.W2TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="editForm.W2TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="editForm.W2TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW2_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="周三课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="editForm.W3CourseId" class="course-select"
                @change="editForm.W3CourseId2 = $event; getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW3'); getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW3_2'); editForm.W3TeacherInfoId = null; editForm.W3TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="editForm.W3CourseId2" class="course-select"
                @change="getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW3_2'); editForm.W3TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="editForm.W3TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW3" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="editForm.W3TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW3_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="周四课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="editForm.W4CourseId" class="course-select"
                @change="editForm.W4CourseId2 = $event; getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW4'); getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW4_2'); editForm.W4TeacherInfoId = null; editForm.W4TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="editForm.W4CourseId2" class="course-select"
                @change="getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW4_2'); editForm.W4TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="editForm.W4TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW4" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="editForm.W4TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW4_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="周五课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="editForm.W5CourseId" class="course-select"
                @change="editForm.W5CourseId2 = $event; getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW5'); getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW5_2'); editForm.W5TeacherInfoId = null; editForm.W5TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="editForm.W5CourseId2" class="course-select"
                @change="getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW5_2'); editForm.W5TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="editForm.W5TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW5" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="editForm.W5TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW5_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="周六课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="editForm.W6CourseId" class="course-select"
                @change="editForm.W6CourseId2 = $event; getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW6'); getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW6_2'); editForm.W6TeacherInfoId = null; editForm.W6TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="editForm.W6CourseId2" class="course-select"
                @change="getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW6_2'); editForm.W6TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="editForm.W6TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW6" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="editForm.W6TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW6_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="周日课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="editForm.W7CourseId" class="course-select"
                @change="editForm.W7CourseId2 = $event; getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW7'); getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW7_2'); editForm.W7TeacherInfoId = null; editForm.W7TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="editForm.W7CourseId2" class="course-select"
                @change="getTeachers(editForm.Dids[editForm.Dids.length - 1], $event, 'teacherListW7_2'); editForm.W7TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="editForm.W7TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW7" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="editForm.W7TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW7_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增科目" width="60%" :visible.sync="addFormVisible" v-model="addFormVisible"
        :close-on-click-modal="false" @close="onAddDialogClose">
        <el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm">

          <el-form-item label="所属机构" prop="Dids">
            <el-input v-if="deptCascaderLocked" :value="lockedDepartmentName || currentDepartmentName" disabled style="width: 100%" />
            <el-cascader v-else placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids" :options="options"
              :show-all-levels="false" filterable :key="cascaderKey"
              :props="$deptCascaderProps" @change="handleClassChange"></el-cascader>
          </el-form-item>
          <el-form-item label="方案">
            <span style="color:var(--btn-primary, #2563eb)">{{ scheduleName || '未选择' }}</span>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="节次选择" prop="SchoolSchedulePeriodId">
                <el-select style="width:100%" v-model="addForm.SchoolSchedulePeriodId" placeholder="请选择节次"
                  @change="onSchedulePeriodChange('add', $event)">
                  <el-option v-for="s in scheduleList" :key="getScheduleOptionKey(s)" :label="formatScheduleLabel(s)"
                    :value="getScheduleOptionValue(s)"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="课程开始时间:" prop="StartTime">
                <el-time-picker v-model="addForm.StartTime" placeholder="请选择开始时间" style="width: 100%;"
                  value-format="HH:mm" format="HH:mm" disabled></el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程结束时间:" prop="EndTime">
                <el-time-picker v-model="addForm.EndTime" placeholder="请选择结束时间" style="width: 100%;"
                  value-format="HH:mm" format="HH:mm" disabled></el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="序号" prop="ClassNo">
                <el-input v-model="addForm.ClassNo" type="number" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提前考勤(分钟)" prop="EarlyEnterTime">
                <el-input v-model="addForm.EarlyEnterTime" type="number" min="0" placeholder="请输入提前考勤时间"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="周一课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="addForm.W1CourseId" class="course-select"
                @change="addForm.W1CourseId2 = $event; getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW1'); getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW1_2'); addForm.W1TeacherInfoId = null; addForm.W1TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="addForm.W1CourseId2" class="course-select"
                @change="getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW1_2'); addForm.W1TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="addForm.W1TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW1" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="addForm.W1TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW1_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="周二课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="addForm.W2CourseId" class="course-select"
                @change="addForm.W2CourseId2 = $event; getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW2'); getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW2_2'); addForm.W2TeacherInfoId = null; addForm.W2TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="addForm.W2CourseId2" class="course-select"
                @change="getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW2_2'); addForm.W2TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="addForm.W2TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="addForm.W2TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW2_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="周三课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="addForm.W3CourseId" class="course-select"
                @change="addForm.W3CourseId2 = $event; getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW3'); getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW3_2'); addForm.W3TeacherInfoId = null; addForm.W3TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="addForm.W3CourseId2" class="course-select"
                @change="getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW3_2'); addForm.W3TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="addForm.W3TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW3" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="addForm.W3TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW3_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="周四课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="addForm.W4CourseId" class="course-select"
                @change="addForm.W4CourseId2 = $event; getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW4'); getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW4_2'); addForm.W4TeacherInfoId = null; addForm.W4TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="addForm.W4CourseId2" class="course-select"
                @change="getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW4_2'); addForm.W4TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="addForm.W4TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW4" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="addForm.W4TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW4_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="周五课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="addForm.W5CourseId" class="course-select"
                @change="addForm.W5CourseId2 = $event; getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW5'); getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW5_2'); addForm.W5TeacherInfoId = null; addForm.W5TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="addForm.W5CourseId2" class="course-select"
                @change="getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW5_2'); addForm.W5TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="addForm.W5TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW5" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="addForm.W5TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW5_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="周六课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="addForm.W6CourseId" class="course-select"
                @change="addForm.W6CourseId2 = $event; getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW6'); getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW6_2'); addForm.W6TeacherInfoId = null; addForm.W6TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="addForm.W6CourseId2" class="course-select"
                @change="getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW6_2'); addForm.W6TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="addForm.W6TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW6" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="addForm.W6TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW6_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="周日课程:">
            <div class="course-row">
              <span class="course-label">单周课程:</span>
              <el-select v-model="addForm.W7CourseId" class="course-select"
                @change="addForm.W7CourseId2 = $event; getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW7'); getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW7_2'); addForm.W7TeacherInfoId = null; addForm.W7TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周课程:</span>
              <el-select v-model="addForm.W7CourseId2" class="course-select"
                @change="getTeachers(addForm.Dids[addForm.Dids.length - 1], $event, 'teacherListW7_2'); addForm.W7TeacherInfoId2 = null"
                clearable placeholder="未指定">
                <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">单周教师:</span>
              <el-select v-model="addForm.W7TeacherInfoId" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW7" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
              <span class="course-label">双周教师:</span>
              <el-select v-model="addForm.W7TeacherInfoId2" class="teacher-select" clearable placeholder="未指定">
                <el-option v-for="item in teacherListW7_2" :key="item.Id" :label="item.TeacherName"
                  :value="item.Id"></el-option>
              </el-select>
            </div>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 节次配置（点击课表格子打开，固定为所点星期） -->
      <el-dialog :title="quickEditTitle" :visible.sync="quickEditVisible" width="680px"
        :close-on-click-modal="false" append-to-body custom-class="quick-edit-dialog">
        <div class="qe-body" v-loading="quickEditLoading">
        <div class="qe-header">
          <div class="qe-header-top">
            <el-tag size="small" effect="plain" class="qe-period-tag">{{ quickEditMeta.periodName }}</el-tag>
            <span v-if="quickEditMeta.timeRange" class="qe-time">
              <i class="el-icon-time"></i>{{ quickEditMeta.timeRange }}
            </span>
          </div>
          <div v-if="quickEditMeta.departmentName" class="qe-class-path">
            <i class="el-icon-location-outline"></i>
            <span>{{ quickEditMeta.departmentName }}</span>
          </div>
        </div>

        <el-tabs
          v-model="quickEditMainTab"
          class="qe-tabs"
          :class="{ 'qe-tabs--single': !quickEditShowStudentConfig }"
          @tab-click="onQuickEditMainTabClick"
        >
          <el-tab-pane label="任课教师" name="teacher">
            <div class="qe-week-grid">
              <div class="qe-week-card">
                <div class="qe-week-card__head">
                  <span class="qe-week-card__badge">单</span>
                  <span class="qe-week-card__title">单周</span>
                </div>
                <el-form label-width="56px" label-position="left" size="small" class="qe-form">
                  <el-form-item label="课程">
                    <el-select :value="quickEditForm['W' + quickEditDayNum + 'CourseId']" class="qe-field" clearable
                      placeholder="请选择课程" @change="onQuickEditCourseChange(quickEditDayNum, false, $event)">
                      <el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="教师">
                    <el-select v-model="quickEditForm['W' + quickEditDayNum + 'TeacherInfoId']" class="qe-field"
                      clearable filterable placeholder="请选择教师">
                      <el-option v-for="item in getTeacherListForDay(quickEditDayNum, '')" :key="item.Id"
                        :label="item.TeacherName" :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="quickEditShowRoom" label="教室">
                    <el-select
                      :value="quickEditForm['W' + quickEditDayNum + 'ResourceDepartmentId']"
                      class="qe-field"
                      clearable
                      filterable
                      placeholder="本班教室（可不选）"
                      @change="onQuickEditRoomChange(quickEditDayNum, false, $event)">
                      <el-option
                        v-for="item in resourceRoomOptions"
                        :key="'r1-' + item.id"
                        :label="item.label"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div class="qe-week-card qe-week-card--alt">
                <div class="qe-week-card__head">
                  <span class="qe-week-card__badge qe-week-card__badge--alt">双</span>
                  <span class="qe-week-card__title">双周</span>
                </div>
                <el-form label-width="56px" label-position="left" size="small" class="qe-form">
                  <el-form-item label="课程">
                    <el-select :value="quickEditForm['W' + quickEditDayNum + 'CourseId2']" class="qe-field" clearable
                      placeholder="请选择课程" @change="onQuickEditCourseChange(quickEditDayNum, true, $event)">
                      <el-option v-for="item in courseList" :key="'d2-' + item.Id" :label="item.CourseName"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="教师">
                    <el-select v-model="quickEditForm['W' + quickEditDayNum + 'TeacherInfoId2']" class="qe-field"
                      clearable filterable placeholder="请选择教师">
                      <el-option v-for="item in getTeacherListForDay(quickEditDayNum, '_2')" :key="'t2-' + item.Id"
                        :label="item.TeacherName" :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="quickEditShowRoom" label="教室">
                    <el-select
                      :value="quickEditForm['W' + quickEditDayNum + 'ResourceDepartmentId2']"
                      class="qe-field"
                      clearable
                      filterable
                      placeholder="本班教室（可不选）"
                      @change="onQuickEditRoomChange(quickEditDayNum, true, $event)">
                      <el-option
                        v-for="item in resourceRoomOptions"
                        :key="'r2-' + item.id"
                        :label="item.label"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="quickEditShowStudentConfig" label="配置上课人员" name="student">
            <div class="qe-student-summary">
              <div class="qe-student-summary__item" v-if="studentConfigForm.courseName">
                <span class="qe-student-summary__label">科目</span>
                <span class="qe-student-summary__value">{{ studentConfigForm.courseName }}</span>
              </div>
              <div class="qe-student-summary__item" v-if="studentConfigForm.teacherName">
                <span class="qe-student-summary__label">教师</span>
                <span class="qe-student-summary__value">{{ studentConfigForm.teacherName }}</span>
              </div>
            </div>
            <el-form :model="studentConfigForm" label-width="88px" size="small" class="qe-form" v-loading="studentConfigLoading">
              <el-form-item label="人员来源">
                <el-radio-group v-model="studentConfigForm.useFullClass" class="qe-radio-group">
                  <el-radio :label="true">全班人员</el-radio>
                  <el-radio :label="false">自定义选择</el-radio>
                </el-radio-group>
              </el-form-item>
              <div v-if="!studentConfigForm.useFullClass" class="qe-transfer-block">
                <p class="qe-transfer-tip">从左侧待选列表勾选本节课实际上课学生</p>
                <div class="qe-transfer-wrap">
                  <el-transfer v-model="studentConfigForm.selectedStudents" :data="studentList"
                    :titles="['待选学生', '上课学生']" filterable filter-placeholder="搜索姓名" :props="{
                      key: 'Id',
                      label: 'Name'
                    }"></el-transfer>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        </div>
        <div slot="footer" class="qe-footer">
          <el-button size="medium" @click="quickEditVisible = false">取消</el-button>
          <el-button size="medium" type="primary" @click="saveQuickEditPanel"
            :loading="quickEditShowStudentConfig && quickEditMainTab === 'student' ? studentConfigLoading : quickEditSaving">保存</el-button>
        </div>
      </el-dialog>

    </section>

    <!-- 代调课详情弹窗 -->
    <el-dialog title="代调课详情" :visible.sync="adjustmentDialogVisible" width="550px" append-to-body
      custom-class="adjustment-dialog" :close-on-click-modal="false">
      <div v-if="currentAdjustments && currentAdjustments.length" style="padding: 0 10px;">
        <div v-for="(adj, index) in currentAdjustments" :key="index" class="adjustment-card"
          style="margin-bottom: 15px; border-radius: 8px; border: 1px solid #e4e7ed; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05); overflow: hidden; transition: all 0.3s;">

          <!-- 头部：日期和类型 -->
          <div
            style="background-color: #fcfcfc; padding: 12px 20px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #ebeef5;">
            <div style="display: flex; align-items: center;">
              <el-tag size="small" :type="adj.type.indexOf('调') > -1 ? 'warning' : 'danger'" effect="dark"
                style="margin-right: 12px; border-radius: 4px;">{{ adj.type }}</el-tag>
              <span style="font-weight: 600; color: #606266; font-size: 15px;">{{ adj.date }}</span>
            </div>
            <el-tag v-if="adj.weekType" size="small" type="danger" effect="plain" style="border-radius: 4px;">
              {{ adj.weekType === '1' ? '双周' : (adj.weekType === '0' ? '单周' : '') }}
            </el-tag>
          </div>

          <!-- 内容：课程和教师 -->
          <div style="padding: 20px; display: flex; align-items: center; background-color: #fff;">
            <div style="flex: 1; display: flex; align-items: center;">
              <div
                style="width: 40px; height: 40px; border-radius: 50%; background-color: #ecf5ff; display: flex; justify-content: center; align-items: center; margin-right: 12px; color: var(--btn-primary, #2563eb);">
                <i class="el-icon-reading" style="font-size: 20px;"></i>
              </div>
              <div>
                <div style="font-size: 12px; color: #909399; margin-bottom: 4px;">课程名称</div>
                <div style="font-size: 16px; color: #303133; font-weight: 600;">{{ adj.course }}</div>
              </div>
            </div>

            <div style="width: 1px; height: 40px; background: #ebeef5; margin: 0 20px;"></div>

            <div style="flex: 1; display: flex; align-items: center;">
              <div
                style="width: 40px; height: 40px; border-radius: 50%; background-color: #f0f9eb; display: flex; justify-content: center; align-items: center; margin-right: 12px; color: #67C23A;">
                <i class="el-icon-user" style="font-size: 20px;"></i>
              </div>
              <div>
                <div style="font-size: 12px; color: #909399; margin-bottom: 4px;">授课教师</div>
                <div style="font-size: 16px; color: #303133; font-weight: 600;">{{ adj.teacher }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else
        style="min-height: 200px; display: flex; flex-direction: column; justify-content: center; align-items: center; color: #909399;">
        <i class="el-icon-document-remove" style="font-size: 48px; margin-bottom: 10px; color: #dcdfe6;"></i>
        <span>暂无代调课信息</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="adjustmentDialogVisible = false" style="min-width: 100px;">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 班级课表导入弹窗：下载模板 → 预览核对 → 导入结果 -->
    <input type="file" ref="upload" accept=".xls,.xlsx" class="outputlist_upload" style="display: none"
      v-if="excelInput" @change="readExcel" />
    <el-dialog
      :visible.sync="importDialogVisible"
      :close-on-click-modal="false"
      :width="importStep === 1 ? '640px' : '1200px'"
      title="导入班级课表"
      custom-class="dept-course-import-dialog"
      append-to-body
      @closed="resetImportDialog"
    >
      <el-steps :active="importStep" finish-status="success" align-center class="dept-course-import-steps">
        <el-step title="下载模板与选择文件"></el-step>
        <el-step title="数据预览核对"></el-step>
        <el-step title="导入结果"></el-step>
      </el-steps>

      <!-- Step 1 -->
      <div v-if="importStep === 1" class="dept-course-import-step dept-course-import-step--setup">
        <div class="dept-course-import-guide">
          <p class="dept-course-import-guide__title">填写说明</p>
          <ul class="dept-course-import-tips">
            <li>周课表矩阵：前两列为<span class="is-important">校区、班级</span>，其后为一～五第 N 节；格子内第一行课程（可写<span class="is-important">单周/双周</span>），第二行教师（可写<span class="is-important">单周/双周</span>）。导入到顶部当前学校。</li>
            <li><span class="is-important">多校区同名班级须填写校区</span>（与系统校区名称/简称一致）；单校区可留空校区列。</li>
            <li><span class="is-important">班级须与系统名称或简称全文一致</span>（如「六年级14班」）。</li>
            <li>科目不存在会自动创建；<span class="is-important">教师须已在系统中</span>，缺任职/任教会自动补全。</li>
            <li>模板中的<span class="is-important">「示例校区」样例行会自动忽略</span>，也可手动删除后再填写真实数据。</li>
            <li><span class="is-important">同一班级同一节次已有课表会直接覆盖更新</span>，不会因已存在而跳过或提示中断。</li>
            <li>Excel「第 N 节」对应作息排序后的第 N 个节次，支持 .xls / .xlsx。</li>
          </ul>
        </div>
        <div class="dept-course-import-actions">
          <button type="button" class="dept-course-import-action" @click="downloadImportTemplate">
            <i class="el-icon-download"></i>
            <span class="dept-course-import-action__title">下载导入模板</span>
            <span class="dept-course-import-action__desc">按模板格式填写后上传</span>
          </button>
          <button type="button" class="dept-course-import-action" @click="exportCurrentTimetable">
            <i class="el-icon-document"></i>
            <span class="dept-course-import-action__title">导出当前课表</span>
            <span class="dept-course-import-action__desc">导出后可改再导入</span>
          </button>
          <button type="button" class="dept-course-import-action" @click="triggerImportFile">
            <i class="el-icon-upload2"></i>
            <span class="dept-course-import-action__title">选择 Excel 文件</span>
            <span class="dept-course-import-action__desc">支持 .xls / .xlsx</span>
          </button>
        </div>
      </div>

      <!-- Step 2 -->
      <div v-if="importStep === 2" class="dept-course-import-step dept-course-import-step--preview">
        <div class="dept-course-import-panel">
          <div class="dept-course-import-panel__head">
            <div class="dept-course-import-panel__meta">
              <span class="dept-course-import-panel__title">数据预览</span>
              <span class="dept-course-import-panel__count">共 {{ outputs.length }} 条</span>
              <span v-if="importPreviewKeyword.trim()" class="dept-course-import-panel__count is-filter">
                筛选 {{ importPreviewFilteredRows.length }} 条
              </span>
            </div>
            <el-input
              v-model="importPreviewKeyword"
              class="dept-course-import-search"
              size="small"
              clearable
              prefix-icon="el-icon-search"
              placeholder="搜索校区 / 班级 / 课程 / 教师"
              style="width: 240px"
              @input="importPreviewPage = 1"
            ></el-input>
          </div>
          <p class="dept-course-import-panel__tip">导入前会整批校验：存在任一行异常时不会写入任何数据，请先修正后再导入。同一班级同一节次已有课表会覆盖更新，可先删除不需要的行。</p>
          <div class="dept-course-import-panel__body">
            <el-table
              :data="importPreviewPageRows"
              class="dept-course-import-table"
              max-height="380"
              size="small"
              border
              stripe
              style="width: 100%"
              :empty-text="importPreviewKeyword.trim() ? '没有匹配的数据，请调整搜索关键词' : '暂无数据'"
            >
              <el-table-column label="#" width="50" align="center">
                <template slot-scope="scope">{{ importPreviewRowIndex(scope.$index) }}</template>
              </el-table-column>
              <el-table-column prop="CampusName" label="校区" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.CampusName || '—' }}</template>
              </el-table-column>
              <el-table-column prop="DepartmentName" label="班级" min-width="112" show-overflow-tooltip></el-table-column>
              <el-table-column prop="ClassNo" label="第几节" width="70" align="center"></el-table-column>
              <el-table-column
                v-for="day in importPreviewDayColumns"
                :key="'preview-day-' + day"
                :label="importDayLabels[day]"
                min-width="156"
              >
                <template slot-scope="scope">
                  <div class="dept-course-import-day" :title="formatImportDayCell(scope.row, day)">
                    <div class="dept-course-import-day__course">{{ getImportDayCourse(scope.row, day) || '—' }}</div>
                    <div v-if="getImportDayTeacher(scope.row, day)" class="dept-course-import-day__teacher">
                      {{ getImportDayTeacher(scope.row, day) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" align="center" width="70">
                <template slot-scope="scope">
                  <el-button type="text" class="dept-course-import-remove" @click="removeImport(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dept-course-import-panel__foot">
            <el-pagination
              class="dept-course-import-pager"
              background
              layout="total, sizes, prev, pager, next"
              :total="importPreviewFilteredRows.length"
              :page-sizes="[10, 20, 50]"
              :page-size="importDetailPageSize"
              :current-page.sync="importPreviewPage"
              small
              @size-change="onImportPreviewPageSizeChange"
            ></el-pagination>
          </div>
        </div>
      </div>

      <!-- Step 3 -->
      <div v-if="importStep === 3" class="dept-course-import-step dept-course-import-step--result">
        <div class="dept-course-import-result">
          <i
            :class="importResult.FailCount === 0 ? 'el-icon-success' : 'el-icon-warning'"
            class="dept-course-import-result-icon"
            :style="{ color: importResult.FailCount === 0 ? '#67C23A' : '#E6A23C' }"
          ></i>
          <p v-if="importResult.FailCount > 0 && importResult.SuccessCount === 0" class="dept-course-import-result-title">
            校验未通过，共 <em class="is-fail">{{ importResult.FailCount }}</em> 行异常，未导入任何数据
          </p>
          <p v-else class="dept-course-import-result-title">
            成功 <em class="is-success">{{ importResult.SuccessCount }}</em> 条
            <span v-if="importResult.AddCount || importResult.UpdateCount" class="dept-course-import-result-sub">
              （新增 {{ importResult.AddCount || 0 }} / 更新 {{ importResult.UpdateCount || 0 }}）
            </span>
            ，失败 <em class="is-fail">{{ importResult.FailCount }}</em> 行
          </p>
          <p v-if="importResult.Message" class="dept-course-import-result-msg">{{ importResult.Message }}</p>
        </div>

        <div class="dept-course-import-panel">
          <div class="dept-course-import-panel__head">
            <div class="dept-course-import-seg">
              <button
                type="button"
                class="dept-course-import-seg__btn"
                :class="{ 'is-active': importResultTab === 'success' }"
                @click="switchImportResultTab('success')"
              >
                成功 <em>{{ importSuccessRows.length }}</em>
              </button>
              <button
                type="button"
                class="dept-course-import-seg__btn"
                :class="{ 'is-active': importResultTab === 'fail', 'is-fail': true }"
                @click="switchImportResultTab('fail')"
              >
                失败 <em>{{ importErrorRows.length }}</em>
              </button>
            </div>
            <el-input
              v-model="importResultKeyword"
              class="dept-course-import-search"
              size="small"
              clearable
              prefix-icon="el-icon-search"
              :placeholder="importResultTab === 'fail' ? '搜索失败原因' : '搜索班级 / 结果'"
              style="width: 220px"
              @input="onImportResultKeywordInput"
            ></el-input>
          </div>
          <div class="dept-course-import-panel__body">
            <el-table
              v-if="importResultTab === 'success'"
              :data="importSuccessPageRows"
              class="dept-course-import-table"
              max-height="300"
              size="small"
              border
              stripe
              style="width: 100%"
              :empty-text="importResultKeyword.trim() ? '没有匹配的数据' : '暂无成功明细'"
            >
              <el-table-column prop="RowIndex" label="#" width="50" align="center"></el-table-column>
              <el-table-column prop="DepartmentName" label="班级" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column prop="ExcelClassNo" label="第几节" width="80" align="center"></el-table-column>
              <el-table-column prop="Action" label="结果" width="80" align="center">
                <template slot-scope="scope">
                  <span :class="scope.row.Action === '新增' ? 'is-add' : 'is-update'">{{ scope.row.Action }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-table
              v-else
              :data="importErrorPageRows"
              class="dept-course-import-table"
              max-height="300"
              size="small"
              border
              stripe
              style="width: 100%"
              :empty-text="importResultKeyword.trim() ? '没有匹配的数据' : '暂无失败明细'"
            >
              <el-table-column prop="index" label="#" width="50" align="center"></el-table-column>
              <el-table-column prop="msg" label="原因" min-width="400" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
          <div
            v-if="importResultTab === 'success' ? importSuccessFilteredRows.length > importDetailPageSize : importErrorFilteredRows.length > importDetailPageSize"
            class="dept-course-import-panel__foot"
          >
            <el-pagination
              v-if="importResultTab === 'success'"
              class="dept-course-import-pager"
              background
              layout="total, prev, pager, next"
              :total="importSuccessFilteredRows.length"
              :page-size="importDetailPageSize"
              :current-page.sync="importSuccessPage"
              small
            ></el-pagination>
            <el-pagination
              v-else
              class="dept-course-import-pager"
              background
              layout="total, prev, pager, next"
              :total="importErrorFilteredRows.length"
              :page-size="importDetailPageSize"
              :current-page.sync="importErrorPage"
              small
            ></el-pagination>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="importStep === 1" @click="importDialogVisible = false">取 消</el-button>
        <el-button v-if="importStep === 2" @click="importStep = 1">重新选择文件</el-button>
        <el-button v-if="importStep === 2" type="primary" :loading="importSaving" :disabled="!outputs.length" @click="SavaImport">开始导入</el-button>
        <el-button
          v-if="importStep === 3 && importResult.FailCount > 0 && importResult.SuccessCount === 0"
          @click="importStep = 2"
        >返回修改</el-button>
        <el-button v-if="importStep === 3" @click="continueImport">继续导入</el-button>
        <el-button v-if="importStep === 3" type="primary" @click="importDialogVisible = false">完 成</el-button>
      </span>
    </el-dialog>

    <!-- 一键迁移课表到默认作息：预览 → 二次确认。创建于 2026-09-20 -->
    <el-dialog
      title="一键迁移课表到默认作息"
      :visible.sync="migrateDialogVisible"
      width="780px"
      top="4vh"
      :close-on-click-modal="false"
      append-to-body
      custom-class="dept-course-migrate-dialog"
      @opened="onMigrateDialogOpened"
      @closed="onMigrateDialogClosed">
      <div v-loading="migratePreviewLoading" class="migrate-dialog-body">
        <el-alert
          type="warning"
          :closable="false"
          show-icon
          title="按「第几节」把课表节次重绑到当前默认作息，并覆盖开始/结束时间。请先在「休息时间」将目标方案设为默认。"
          style="margin-bottom: 12px;">
        </el-alert>
        <div v-if="migratePreview" class="migrate-summary">
          <span>扫描 <em>{{ migratePreview.TotalCount || 0 }}</em> 条</span>
          <span>可更新 <em class="is-update">{{ migratePreview.UpdatedCount || 0 }}</em></span>
          <span>已对齐 <em>{{ migratePreview.SkippedAlreadyAligned || 0 }}</em></span>
          <span>无匹配节次 <em class="is-fail">{{ migratePreview.SkippedNoMatchClassNo || 0 }}</em></span>
          <span>无目标作息 <em class="is-fail">{{ migratePreview.SkippedNoTargetSchedule || 0 }}</em></span>
        </div>
        <div v-if="migratePreview" class="migrate-filters">
          <el-input
            v-model="migrateFilterKeyword"
            size="mini"
            clearable
            prefix-icon="el-icon-search"
            placeholder="班级 / 作息 / 说明"
            style="width: 200px;"
            @input="migratePage = 1">
          </el-input>
          <el-select
            v-model="migrateFilterAction"
            size="mini"
            clearable
            placeholder="状态"
            style="width: 130px;"
            @change="migratePage = 1">
            <el-option label="将更新" value="WillUpdate"></el-option>
            <el-option label="已对齐" value="AlreadyAligned"></el-option>
            <el-option label="无匹配节次" value="NoMatchClassNo"></el-option>
            <el-option label="无目标作息" value="NoTargetSchedule"></el-option>
          </el-select>
          <el-select
            v-model="migrateFilterClassNo"
            size="mini"
            clearable
            placeholder="节次"
            style="width: 100px;"
            @change="migratePage = 1">
            <el-option
              v-for="n in migrateFilterClassNoOptions"
              :key="n"
              :label="'第' + n + '节'"
              :value="n">
            </el-option>
          </el-select>
        </div>
        <el-table
          v-if="migratePreviewAllRows.length"
          :data="migratePreviewPageRows"
          size="mini"
          border
          :height="migrateTableHeight"
          style="width: 100%; margin-top: 10px;">
          <el-table-column prop="ClassName" label="班级" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="节次" width="70" align="center">
            <template slot-scope="scope">第{{ scope.row.ClassNo }}节</template>
          </el-table-column>
          <el-table-column prop="TargetScheduleName" label="目标作息" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="时间" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.Action === 'WillUpdate'">{{ scope.row.OldTimeRange || '-' }} → {{ scope.row.NewTimeRange || '-' }}</span>
              <span v-else>{{ scope.row.OldTimeRange || scope.row.NewTimeRange || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Reason" label="说明" min-width="140" show-overflow-tooltip></el-table-column>
        </el-table>
        <p v-else-if="!migratePreviewLoading && migratePreviewSortedRows.length" class="migrate-empty">无匹配筛选结果</p>
        <p v-else-if="!migratePreviewLoading" class="migrate-empty">暂无预览数据</p>
      </div>
      <div slot="footer" class="migrate-dialog-footer">
        <div v-if="migratePreviewAllRows.length" class="migrate-pagination">
          <el-pagination
            small
            background
            :layout="migratePaginationLayout"
            :total="migratePreviewAllRows.length"
            :current-page.sync="migratePage"
            :page-size.sync="migratePageSize"
            :page-sizes="[10, 20, 50, 100]"
            :pager-count="5"
            @size-change="migratePage = 1">
          </el-pagination>
        </div>
        <div class="dialog-footer migrate-dialog-actions">
          <el-button @click="migrateDialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            :loading="migrateSaving"
            :disabled="!migratePreview || !(migratePreview.UpdatedCount > 0)"
            @click="confirmMigrateTimetable">
            确认迁移
          </el-button>
        </div>
      </div>
    </el-dialog>

  </section>

</template>

<script>
import util from "../../../util/date";
import { getDeptCourseListPage, editDeptCourse, addDeptCourse, deleteDeptCourse, GetSysCourseByDepartmentId, batchAddDeptCourse, getScheduleByClass, getDeptCourseStudentConfig, saveDeptCourseStudentConfig, getAdjustmentList, getWeekSchedule, previewMigrateTimetableToDefaultSchedule, migrateTimetableToDefaultSchedule, exportTimetableMatrix } from '../../api/modules/schedule-course';
import { getSemesterWeeksByClassId } from '../../api/modules/misc';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import {
  prepareDeptCascaderTree,
  resolveActiveSchoolId,
  normalizeDeptId,
  treeNodeDeptId,
  sanitizeDeptCascaderIds,
} from '../../utils/deptCascaderProps'
import { BaseApiUrl } from '../../api/base';
import { getTeachersByDeptAndCourse, GetStudentSelectListByClassId } from '../../api/modules/personnel';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";
// excel 读取/导出模板
import { read, utils, writeFile } from 'xlsx'
export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      scheduleList: [], // 按班级获取的节次列表
      scheduleName: '',
      previewPeriod: null,
      courseList: [], // 课程下拉数据
      teacherListW1: [], // 周一教师列表
      teacherListW1_2: [], // 周一双周教师列表
      teacherListW2: [], // 周二教师列表
      teacherListW2_2: [], // 周二双周教师列表
      teacherListW3: [], // 周三教师列表
      teacherListW3_2: [], // 周三双周教师列表
      teacherListW4: [], // 周四教师列表
      teacherListW4_2: [], // 周四双周教师列表
      teacherListW5: [], // 周五教师列表
      teacherListW5_2: [], // 周五双周教师列表
      teacherListW6: [], // 周六教师列表
      teacherListW6_2: [], // 周六双周教师列表
      teacherListW7: [], // 周日教师列表
      teacherListW7_2: [], // 周日双周教师列表
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      viewMode: 'week',
      semesterWeeks: [],
      selectedWeekNumber: null,
      weekScheduleEntries: [],
      weekDayRules: [],
      weekCellMap: {},
      weekPeriods: [],
      weekLoadSeq: 0,
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: null,
      //编辑界面数据
      editForm: {
        Id: 0,
        ClassNo: '',        // 课程序号
        StartTime: '',      // 课程开始时间 HH:mm
        EndTime: '',        // 课程结束时间 HH:mm
        W1CourseId: null,   // 周一课程id
        W1CourseId2: null,  // 周一课程id(双周)
        W1TeacherInfoId: null,  // 周一教师id
        W1TeacherInfoId2: null, // 周一教师id(双周)
        W2CourseId: null,   // 周二课程id
        W2CourseId2: null,  // 周二课程id(双周)
        W2TeacherInfoId: null,  // 周二教师id
        W2TeacherInfoId2: null, // 周二教师id(双周)
        W3CourseId: null,   // 周三课程id
        W3CourseId2: null,  // 周三课程id(双周)
        W3TeacherInfoId: null,  // 周三教师id
        W3TeacherInfoId2: null, // 周三教师id(双周)
        W4CourseId: null,   // 周四课程id
        W4CourseId2: null,  // 周四课程id(双周)
        W4TeacherInfoId: null,  // 周四教师id
        W4TeacherInfoId2: null, // 周四教师id(双周)
        W5CourseId: null,   // 周五课程id
        W5CourseId2: null,  // 周五课程id(双周)
        W5TeacherInfoId: null,  // 周五教师id
        W5TeacherInfoId2: null, // 周五教师id(双周)
        W6CourseId: null,   // 周六课程id
        W6CourseId2: null,  // 周六课程id(双周)
        W6TeacherInfoId: null,  // 周六教师id
        W6TeacherInfoId2: null, // 周六教师id(双周)
        W7CourseId: null,   // 周日课程id
        W7CourseId2: null,  // 周日课程id(双周)
        W7TeacherInfoId: null,  // 周日教师id
        W7TeacherInfoId2: null, // 周日教师id(双周)
        Dids: [],
        DepartmentId: 0,
        EarlyEnterTime: 0,
        SchoolSchedulePeriodId: null,
      },
      isResouceShow: 0,
      cascaderKey: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      editDataLoading: false, // 编辑对话框的数据加载状态
      addFormRules: null,
      //新增界面数据
      addForm: {
        ClassNo: '',        // 课程序号
        StartTime: '',      // 课程开始时间 HH:mm
        EndTime: '',        // 课程结束时间 HH:mm
        W1CourseId: null,   // 周一课程id
        W1CourseId2: null,  // 周一课程id(双周)
        W1TeacherInfoId: null,  // 周一教师id
        W1TeacherInfoId2: null, // 周一教师id(双周)
        W2CourseId: null,   // 周二课程id
        W2CourseId2: null,  // 周二课程id(双周)
        W2TeacherInfoId: null,  // 周二教师id
        W2TeacherInfoId2: null, // 周二教师id(双周)
        W3CourseId: null,   // 周三课程id
        W3CourseId2: null,  // 周三课程id(双周)
        W3TeacherInfoId: null,  // 周三教师id
        W3TeacherInfoId2: null, // 周三教师id(双周)
        W4CourseId: null,   // 周四课程id
        W4CourseId2: null,  // 周四课程id(双周)
        W4TeacherInfoId: null,  // 周四教师id
        W4TeacherInfoId2: null, // 周四教师id(双周)
        W5CourseId: null,   // 周五课程id
        W5CourseId2: null,  // 周五课程id(双周)
        W5TeacherInfoId: null,  // 周五教师id
        W5TeacherInfoId2: null, // 周五教师id(双周)
        W6CourseId: null,   // 周六课程id
        W6CourseId2: null,  // 周六课程id(双周)
        W6TeacherInfoId: null,  // 周六教师id
        W6TeacherInfoId2: null, // 周六教师id(双周)
        W7CourseId: null,   // 周日课程id
        W7CourseId2: null,   // 周日课程id(双周)
        W7TeacherInfoId: null,  // 周日教师id
        W7TeacherInfoId2: null, // 周日教师id(双周)
        Dids: [],
        DepartmentId: 0,
        EarlyEnterTime: 0,
        SchoolSchedulePeriodId: null,
      },

      DepartmentId: 0,
      currentDepartmentData: null,
      currentDepartmentNode: null,
      deptCascaderLocked: false,
      lockedDepartmentName: '',
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      currentDepartmentName: '',
      //excel 导入
      outputs: [],
      excelInput: true, //input渲染状态
      importDialogVisible: false,
      importStep: 1, // 1选文件 2预览 3结果
      importSaving: false,
      importDetailPageSize: 10,
      importPreviewPage: 1,
      importPreviewKeyword: '',
      importDayLabels: { 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六', 7: '周日' },
      importResultTab: 'success', // success | fail
      importResultKeyword: '',
      importSuccessPage: 1,
      importErrorPage: 1,
      importResult: {
        SuccessCount: 0,
        AddCount: 0,
        UpdateCount: 0,
        FailCount: 0,
        Errors: [],
        SuccessItems: [],
        Message: '',
      },

      // 一键迁移课表到默认作息。创建于 2026-09-20
      migrateDialogVisible: false,
      migratePreviewLoading: false,
      migrateSaving: false,
      migratePreview: null,
      migratePage: 1,
      migratePageSize: 20,
      migrateTableHeight: 360,
      migrateFilterKeyword: '',
      migrateFilterAction: '',
      migrateFilterClassNo: null,

      // 上课人员配置（嵌入节次配置弹窗）
      studentConfigLoading: false,
      studentConfigForm: {
        useFullClass: true,
        selectedStudents: [],
        departmentId: 0,
        periodId: 0,
        dayOfWeek: 0,
        periodClassNo: 0,
        dayOfWeek: 0,
        periodClassNo: 0,
        courseName: '', // 课程名称
        teacherName: '' // 教师名称
      },
      studentList: [], // 穿梭框源数据

      // 快捷任课编辑
      quickEditVisible: false,
      quickEditLoading: false,
      quickEditSaving: false,
      quickEditMainTab: 'teacher',
      quickEditActiveDay: '1',
      quickEditForm: {},
      quickEditMeta: {
        periodName: '',
        timeRange: '',
        departmentName: '',
      },
      quickEditDayLabels: ['一', '二', '三', '四', '五', '六', '日'],
      /** 节次配置：是否显示「配置上课人员」（暂隐藏） */
      quickEditShowStudentConfig: false,
      /** 节次配置：是否显示「教室」选择（暂隐藏） */
      quickEditShowRoom: false,
      /** 共享教室候选（学校下部门扁平列表） */
      resourceRoomOptions: [],

      // 调课详情弹窗
      adjustmentDialogVisible: false,
      currentAdjustments: [],
      currentAdjPeriod: null,
      currentAdjDay: 0,
      // 全量记录弹窗相关
      adjRecordVisible: false,
      allClassAdjustments: [],
      adjRecordPage: 1,
      adjRecordPageSize: 5,
      adjRecordTotal: 0,
      adjRecordLoading: false,
      todayStr: util.formatDate.format(new Date(), 'yyyy-MM-dd'),
    };
  },
  computed: {
    quickEditTitle() {
      const day = this.quickEditDayNum;
      return `节次配置 - 周${this.quickEditDayLabels[day - 1]}`;
    },
    quickEditDayNum() {
      return Number(this.quickEditActiveDay) || 1;
    },
    canPrevWeek() {
      if (!this.semesterWeeks.length || this.selectedWeekNumber == null) return false;
      const idx = this.semesterWeeks.findIndex(w => w.WeekNumber === this.selectedWeekNumber);
      return idx > 0;
    },
    canNextWeek() {
      if (!this.semesterWeeks.length || this.selectedWeekNumber == null) return false;
      const idx = this.semesterWeeks.findIndex(w => w.WeekNumber === this.selectedWeekNumber);
      return idx >= 0 && idx < this.semesterWeeks.length - 1;
    },
    /** 迁移预览排序后的全量明细（可更新优先）。创建于 2026-09-20 */
    migratePreviewSortedRows() {
      const details = (this.migratePreview && (this.migratePreview.Details || this.migratePreview.details)) || [];
      if (!details.length) return [];
      const willUpdate = details.filter(d => d.Action === 'WillUpdate' || d.action === 'WillUpdate');
      const problems = details.filter(d => {
        const a = d.Action || d.action;
        return a === 'NoMatchClassNo' || a === 'NoTargetSchedule';
      });
      const aligned = details.filter(d => d.Action === 'AlreadyAligned' || d.action === 'AlreadyAligned');
      return willUpdate.concat(problems).concat(aligned);
    },
    /** 迁移预览筛选项：节次列表。创建于 2026-09-20 */
    migrateFilterClassNoOptions() {
      const set = new Set();
      this.migratePreviewSortedRows.forEach((d) => {
        const n = Number(d.ClassNo != null ? d.ClassNo : d.classNo);
        if (n > 0) set.add(n);
      });
      return Array.from(set).sort((a, b) => a - b);
    },
    /** 迁移预览筛选后明细。创建于 2026-09-20 */
    migratePreviewAllRows() {
      const keyword = (this.migrateFilterKeyword || '').toString().trim().toLowerCase();
      const action = this.migrateFilterAction || '';
      const classNo = this.migrateFilterClassNo;
      return this.migratePreviewSortedRows.filter((d) => {
        const a = d.Action || d.action || '';
        if (action && a !== action) return false;
        const n = Number(d.ClassNo != null ? d.ClassNo : d.classNo);
        if (classNo != null && classNo !== '' && n !== Number(classNo)) return false;
        if (keyword) {
          const hay = [
            d.ClassName || d.className,
            d.TargetScheduleName || d.targetScheduleName,
            d.Reason || d.reason,
            d.OldTimeRange || d.oldTimeRange,
            d.NewTimeRange || d.newTimeRange,
          ].join(' ').toLowerCase();
          if (!hay.includes(keyword)) return false;
        }
        return true;
      });
    },
    /** 迁移预览当前页。创建于 2026-09-20 */
    migratePreviewPageRows() {
      const start = (this.migratePage - 1) * this.migratePageSize;
      return this.migratePreviewAllRows.slice(start, start + this.migratePageSize);
    },
    /** 小屏精简分页布局，避免挤出视口。创建于 2026-09-20 */
    migratePaginationLayout() {
      if (typeof window !== 'undefined' && window.innerWidth < 768) {
        return 'total, prev, pager, next';
      }
      return 'total, prev, pager, next, sizes';
    },
    weekDayHeaders() {
      const labels = ['一', '二', '三', '四', '五', '六', '日'];
      const week = this.semesterWeeks.find(w => w.WeekNumber === this.selectedWeekNumber);
      const days = (week && (week.Days || week.days)) || [];
      const today = this.formatDateYmd(new Date());
      const ruleMap = {};
      (this.weekDayRules || []).forEach(r => {
        const wd = r.WeekDay != null ? r.WeekDay : r.weekDay;
        ruleMap[wd] = r;
      });
      return labels.map((lab, i) => {
        const weekDay = i + 1;
        const dayInfo = days.find(d => (d.DayOfWeek || d.dayOfWeek || d.WeekDay || d.weekDay) === weekDay) || days[i];
        const dateVal = dayInfo ? (dayInfo.Date || dayInfo.date) : null;
        const dateObj = dateVal ? new Date(dateVal) : null;
        const dateLabel = dateObj && !isNaN(dateObj.getTime())
          ? `${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`
          : '';
        const rule = ruleMap[weekDay];
        const ruleType = rule ? (rule.RuleType || rule.ruleType) : '';
        let ruleLabel = '';
        let isRest = false;
        if (ruleType === 'Rest') {
          ruleLabel = '放假';
          isRest = true;
        } else if (ruleType === 'FollowWeekday') {
          const fw = rule.FollowWeekDay || rule.followWeekDay;
          const sd = rule.FollowSingleDoubleWeek || rule.followSingleDoubleWeek;
          const sdLabel = sd === 'double' ? '双周' : (sd === 'single' ? '单周' : '');
          ruleLabel = fw
            ? (`上周${labels[fw - 1]}${sdLabel}课`)
            : '调休';
        }
        const dateStr = dateObj && !isNaN(dateObj.getTime()) ? this.formatDateYmd(dateObj) : '';
        return {
          weekDay,
          weekLabel: lab,
          dateLabel,
          isToday: dateStr === today,
          isRest,
          ruleLabel
        };
      });
    },
    /** 导入失败明细表格数据 */
    importErrorRows() {
      const errors = (this.importResult && this.importResult.Errors) || []
      return errors.map((msg, i) => ({ index: i + 1, msg }))
    },
    /** 导入成功明细 */
    importSuccessRows() {
      const items = (this.importResult && this.importResult.SuccessItems) || []
      return items.map((x, i) => ({
        RowIndex: x.RowIndex != null ? x.RowIndex : (x.rowIndex != null ? x.rowIndex : i + 1),
        DepartmentName: x.DepartmentName || x.departmentName || '',
        ExcelClassNo: x.ExcelClassNo != null ? x.ExcelClassNo : (x.excelClassNo != null ? x.excelClassNo : x.ClassNo),
        Action: x.Action || x.action || '',
      }))
    },
    importSuccessFilteredRows() {
      const list = this.importSuccessRows
      const kw = (this.importResultKeyword || '').trim().toLowerCase()
      if (!kw) return list
      return list.filter((row) => {
        const parts = [row.RowIndex, row.DepartmentName, row.ExcelClassNo, row.Action]
        return parts.some((v) => (v == null ? '' : String(v)).toLowerCase().includes(kw))
      })
    },
    importErrorFilteredRows() {
      const list = this.importErrorRows
      const kw = (this.importResultKeyword || '').trim().toLowerCase()
      if (!kw) return list
      return list.filter((row) => {
        const parts = [row.index, row.msg]
        return parts.some((v) => (v == null ? '' : String(v)).toLowerCase().includes(kw))
      })
    },
    importSuccessPageRows() {
      const size = this.importDetailPageSize || 10
      const page = Math.max(1, this.importSuccessPage || 1)
      const start = (page - 1) * size
      return this.importSuccessFilteredRows.slice(start, start + size)
    },
    importErrorPageRows() {
      const size = this.importDetailPageSize || 10
      const page = Math.max(1, this.importErrorPage || 1)
      const start = (page - 1) * size
      return this.importErrorFilteredRows.slice(start, start + size)
    },
    importPreviewFilteredRows() {
      const list = this.outputs || []
      const kw = (this.importPreviewKeyword || '').trim().toLowerCase()
      if (!kw) return list
      return list.filter((row) => {
        const parts = [
          row.CampusName,
          row.DepartmentName,
          row.ClassNo,
          row.W1CourseName, row.W1TeacherName, row.W1TeacherName2,
          row.W2CourseName, row.W2TeacherName, row.W2TeacherName2,
          row.W3CourseName, row.W3TeacherName, row.W3TeacherName2,
          row.W4CourseName, row.W4TeacherName, row.W4TeacherName2,
          row.W5CourseName, row.W5TeacherName, row.W5TeacherName2,
          row.W6CourseName, row.W6TeacherName, row.W6TeacherName2,
          row.W7CourseName, row.W7TeacherName, row.W7TeacherName2,
        ]
        return parts.some((v) => (v == null ? '' : String(v)).toLowerCase().includes(kw))
      })
    },
    importPreviewPageRows() {
      const size = this.importDetailPageSize || 10
      const page = Math.max(1, this.importPreviewPage || 1)
      const start = (page - 1) * size
      return this.importPreviewFilteredRows.slice(start, start + size)
    },
    /** 预览区星期列：周一至周五固定，有数据才显示周六/周日 */
    importPreviewDayColumns() {
      const days = [1, 2, 3, 4, 5]
      if (this.importPreviewHasSaturday) days.push(6)
      if (this.importPreviewHasSunday) days.push(7)
      return days
    },
    /** 预览区：导入数据里是否有周六/周日课程（无则隐藏列） */
    importPreviewHasSaturday() {
      return this.importPreviewHasDay(6)
    },
    importPreviewHasSunday() {
      return this.importPreviewHasDay(7)
    },
    // 将 users 分组为按部门/班级的课表数据，每组包含若干节次
    timetableGroups() {
      const groups = {};
      (this.users || []).forEach(item => {
        const title = item.DepartmentName || item.SchoolName || (item.Department || '未命名');
        if (!groups[title]) groups[title] = { title: title, subtitle: '', periods: [] };
        groups[title].periods.push(item);
      });
      return Object.keys(groups).map(k => {
        const g = groups[k];
        g.periods = g.periods.slice().sort((a, b) => (Number(a.ClassNo) || 0) - (Number(b.ClassNo) || 0));
        return g;
      });
    }
  },
  methods: {
    /** 预览数据某一天是否有课程或教师 */
    importPreviewHasDay(day) {
      const list = this.outputs || []
      return list.some((row) => {
        const course = (row[`W${day}CourseName`] || '').toString().trim()
        const teacher = (row[`W${day}TeacherName`] || '').toString().trim()
        return !!(course || teacher)
      })
    },

    // 格式化部门名称显示
    formatDepartmentName(name) {
      if (!name) return '';
      // 检查是否包含斜杠
      if (name.includes('/')) {
        // 分割并取最后一个部分
        const parts = name.split('/');
        return parts[parts.length - 1];
      } else {
        // 不包含斜杠，直接显示
        return name;
      }
    },


    // 获取显示的教师名称数组（与课程名一致：单周 / 双周）
    getTeachersDisplay(period, day) {
      const normalize = (v) => (v && v !== '/' && v !== '未指定') ? v : '';
      const t1 = normalize(period['W' + day + 'TeacherName']);
      const t2 = normalize(period['W' + day + 'TeacherName2']);
      if (!t1 && !t2) return [];

      const courseName = period['W' + day + 'CourseName'] || '';
      const hasSplitCourse = courseName.includes('/') || courseName.includes('／');

      // 单双周课程不同时，教师也按位展示（如「 / 滕浩」）
      if (hasSplitCourse) {
        if (t1 === t2) return t1 ? [t1] : [];
        return [t1, t2];
      }

      // 单双周同一课程：仅一位教师时合并显示
      if (t1 && t2) return t1 === t2 ? [t1] : [t1, t2];
      return [t1 || t2];
    },

    // 返回单双周共享教室显示文本
    getRoomDisplay(period, day) {
      const parts = [];
      const slots = [
        { nameKey: `W${day}ResourceDepartmentName`, idKey: `W${day}ResourceDepartmentId`, flagKey: `W${day}IsSharedRoom`, label: '单' },
        { nameKey: `W${day}ResourceDepartmentName2`, idKey: `W${day}ResourceDepartmentId2`, flagKey: `W${day}IsSharedRoom2`, label: '双' },
      ];

      slots.forEach(c => {
        const name = period[c.nameKey];
        const id = period[c.idKey];
        const flag = period[c.flagKey];
        const hasRoom = !!(name || (id != null && Number(id) > 0));
        const isShared = flag === true || flag === 'true' || flag === 1 || flag === '1';
        if (hasRoom && (isShared || name)) {
          parts.push((c.label ? (c.label + '：') : '') + this.formatDepartmentName(name || String(id)));
        }
      });

      const uniq = Array.from(new Set(parts));
      return uniq.length ? uniq.join(' / ') : '';
    },

    handleClassChange(val) {
      // 取最后一级班级ID
      const departmentId = Array.isArray(val) ? val[val.length - 1] : val;
      if (departmentId) {
        // 切换班级时先清空节次，避免旧值不在新 options 内触发校验红框
        this.resetSchedulePeriodForAdd();
        GetSysCourseByDepartmentId({ departmentId: departmentId }).then(res => {
          this.courseList = res.data.response || [];
          this.clearOrphanCourseSelections();
          // 预加载已选课程对应的教师列表，确保编辑时回显单/双周教师
          const deptId = departmentId;
          const tryLoadTeachers = (courseKey, teacherListKey) => {
            const courseId = this.editForm[courseKey];
            if (courseId) {
              this.getTeachers(deptId, courseId, teacherListKey);
            } else {
              this[teacherListKey] = [];
            }
          };

          tryLoadTeachers('W1CourseId', 'teacherListW1');
          tryLoadTeachers('W1CourseId2', 'teacherListW1_2');
          tryLoadTeachers('W2CourseId', 'teacherListW2');
          tryLoadTeachers('W2CourseId2', 'teacherListW2_2');
          tryLoadTeachers('W3CourseId', 'teacherListW3');
          tryLoadTeachers('W3CourseId2', 'teacherListW3_2');
          tryLoadTeachers('W4CourseId', 'teacherListW4');
          tryLoadTeachers('W4CourseId2', 'teacherListW4_2');
          tryLoadTeachers('W5CourseId', 'teacherListW5');
          tryLoadTeachers('W5CourseId2', 'teacherListW5_2');
          tryLoadTeachers('W6CourseId', 'teacherListW6');
          tryLoadTeachers('W6CourseId2', 'teacherListW6_2');
          tryLoadTeachers('W7CourseId', 'teacherListW7');
          tryLoadTeachers('W7CourseId2', 'teacherListW7_2');
        });
        // 根据班级获取节次信息，自动填充序号、开始/结束时间，并提供下拉选择
        getScheduleByClass({ classId: departmentId, departmentId: departmentId }).then(r => {
          try {
            const resp = r.data && (r.data.response || r.data) || {};
            // 如果后端返回了包含 Name 和 Periods 的对象
            if (resp && resp.Periods && Array.isArray(resp.Periods)) {
              this.scheduleName = resp.Name || '';
              this.scheduleList = resp.Periods;
            } else {
              const list = Array.isArray(resp) ? resp : (resp && resp.data) || [];
              this.scheduleList = Array.isArray(list) ? list : (list ? [list] : []);
              this.scheduleName = '';
            }
            if (this.scheduleList && this.scheduleList.length > 0) {
              // 默认使用第一条节次（等 options 渲染后再赋值，避免校验状态异常）
              const first = this.scheduleList[0];
              this.previewPeriod = first || null;
              this.$nextTick(() => {
                const periodId = this.resolveSchedulePeriodId(first);
                this.$set(this.addForm, 'SchoolSchedulePeriodId', periodId);
                this.onSelectSchedule('add', periodId);
                this.clearSchedulePeriodValidate('add');
              });
            } else {
              this.scheduleList = [];
              this.addForm.SchoolSchedulePeriodId = null;
              this.addForm.ClassNo = '';
              this.addForm.StartTime = '';
              this.addForm.EndTime = '';
              this.previewPeriod = null;
              this.scheduleName = '';
            }
          } catch (e) {
            this.scheduleList = [];
            this.addForm.SchoolSchedulePeriodId = null;
            this.addForm.ClassNo = '';
            this.addForm.StartTime = '';
            this.addForm.EndTime = '';
            this.previewPeriod = null;
            this.scheduleName = '';
          }
        }).catch(() => {
          this.scheduleList = [];
          this.addForm.SchoolSchedulePeriodId = null;
          this.addForm.ClassNo = '';
          this.addForm.StartTime = '';
          this.addForm.EndTime = '';
          this.previewPeriod = null;
          this.scheduleName = '';
        });
      } else {
        this.courseList = [];
        // 当未选择班级时，清空节次相关字段
        this.scheduleList = [];
        this.addForm.SchoolSchedulePeriodId = null;
        this.addForm.ClassNo = '';
        this.addForm.StartTime = '';
        this.addForm.EndTime = '';
        this.previewPeriod = null;
        this.scheduleName = '';
      }
      // 清空已选课程和教师
      this.addForm.W1CourseId = null;
      this.addForm.W1CourseId2 = null;
      this.addForm.W1TeacherInfoId = null;
      this.addForm.W1TeacherInfoId2 = null;
      this.addForm.W2CourseId = null;
      this.addForm.W2CourseId2 = null;
      this.addForm.W2TeacherInfoId = null;
      this.addForm.W2TeacherInfoId2 = null;
      this.addForm.W3CourseId = null;
      this.addForm.W3CourseId2 = null;
      this.addForm.W3TeacherInfoId = null;
      this.addForm.W3TeacherInfoId2 = null;
      this.addForm.W4CourseId = null;
      this.addForm.W4CourseId2 = null;
      this.addForm.W4TeacherInfoId = null;
      this.addForm.W4TeacherInfoId2 = null;
      this.addForm.W5CourseId = null;
      this.addForm.W5CourseId2 = null;
      this.addForm.W5TeacherInfoId = null;
      this.addForm.W5TeacherInfoId2 = null;
      this.addForm.W6CourseId = null;
      this.addForm.W6CourseId2 = null;
      this.addForm.W6TeacherInfoId = null;
      this.addForm.W6TeacherInfoId2 = null;
      this.addForm.W7CourseId = null;
      this.addForm.W7CourseId2 = null;
      this.addForm.W7TeacherInfoId = null;
      this.addForm.W7TeacherInfoId2 = null;
      // 清空教师列表
      this.teacherListW1 = [];
      this.teacherListW1_2 = [];
      this.teacherListW2 = [];
      this.teacherListW2_2 = [];
      this.teacherListW3 = [];
      this.teacherListW3_2 = [];
      this.teacherListW4 = [];
      this.teacherListW4_2 = [];
      this.teacherListW5 = [];
      this.teacherListW5_2 = [];
      this.teacherListW6 = [];
      this.teacherListW6_2 = [];
      this.teacherListW7 = [];
      this.teacherListW7_2 = [];
    },

    /** 判断是否为班级（末级）节点 */
    isClassDeptData(data, node) {
      if (!data) return false;
      const orgType = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase();
      if (orgType === 'class') return true;
      const childNodes = node && node.childNodes;
      const isLeaf = !childNodes || childNodes.length === 0;
      if (!isLeaf) return false;
      return !['school', 'affiliateschool', 'campus', 'period', 'grade'].includes(orgType);
    },

    /** 从左侧机构树节点还原级联路径 */
    buildPathFromTreeNode(node) {
      if (!node) return [];
      const path = [];
      let cur = node;
      while (cur && cur.data && cur.data.value !== undefined && cur.data.value !== null) {
        const val = treeNodeDeptId(cur.data);
        if (val) {
          path.unshift(val);
        }
        if (!cur.parent || cur.parent.level === 0) break;
        cur = cur.parent;
      }
      return path;
    },

    /** 深拷贝机构树节点，供级联选择器使用（统一走 prepareDeptCascaderTree） */
    cloneDeptTreeNode(node) {
      const prepared = prepareDeptCascaderTree(node ? [node] : []);
      return prepared.length ? prepared[0] : null;
    },

    /** 子节点是否均为班级（可直接平铺展示） */
    hasOnlyClassChildren(node) {
      const children = node && node.children;
      if (!children || !children.length) return false;
      return children.every((child) => {
        const orgType = String(child.DeptOrgType || child.deptOrgType || '').toLowerCase();
        if (orgType === 'class') return true;
        const sub = child.children;
        return !sub || !sub.length;
      });
    },

    /**
     * 以左侧当前选中节点为起点加载级联树（不再从整校「总平台」重选）
     */
    loadDeptCascaderFromSelectedNode() {
      const data = this.currentDepartmentData;
      if (!data) {
        return this.loadDeptCascaderOptions(this.DepartmentId);
      }

      // 左侧树已带子节点：直接以当前节点为根，或平铺其下班列表
      if (data.children && data.children.length > 0) {
        if (this.hasOnlyClassChildren(data)) {
          this.options = data.children.map(c => this.cloneDeptTreeNode(c));
        } else {
          this.options = [this.cloneDeptTreeNode(data)];
        }
        this.cascaderKey++;
        return Promise.resolve([]);
      }

      // 子节点未展开时，按当前节点 id 拉取子树
      const deptId = treeNodeDeptId(data);
      if (!deptId) {
        return this.loadDeptCascaderOptions(this.DepartmentId);
      }

      return getTeachingDepartmentTree({ pid: deptId }).then((res) => {
        const apiRoot = res.data && res.data.response;
        if (apiRoot) {
          apiRoot.label = data.label || apiRoot.label;
          apiRoot.value = apiRoot.value || deptId;
          const children = apiRoot.children || [];
          if (children.length && children.every(c => String(c.DeptOrgType || '').toLowerCase() === 'class')) {
            this.options = children.map(c => this.cloneDeptTreeNode(c));
          } else {
            this.options = prepareDeptCascaderTree([apiRoot]);
          }
        } else {
          this.options = [this.cloneDeptTreeNode(data)].filter(Boolean);
        }
        this.cascaderKey++;
        return [];
      });
    },

    /** 新增时已选班级：预填当前班，并从父级节点加载同级班级供切换 */
    loadDeptCascaderForClassSwitch() {
      const path = this.normalizeCascaderPath(this.buildPathFromTreeNode(this.currentDepartmentNode));
      this.deptCascaderLocked = false;

      const parentNode = this.currentDepartmentNode && this.currentDepartmentNode.parent;
      const parentData = parentNode && parentNode.data;
      if (parentData) {
        if (parentData.children && parentData.children.length) {
          this.options = [this.cloneDeptTreeNode(parentData)];
          this.cascaderKey++;
          return Promise.resolve(path);
        }
        const parentId = treeNodeDeptId(parentData);
        if (parentId) {
          return getTeachingDepartmentTree({ pid: parentId }).then((res) => {
            const apiRoot = res.data && res.data.response;
            if (apiRoot) {
              apiRoot.label = parentData.label || apiRoot.label;
              apiRoot.value = apiRoot.value || parentId;
              this.options = prepareDeptCascaderTree([apiRoot]);
            }
            this.cascaderKey++;
            return path;
          });
        }
      }

      return this.loadDeptCascaderFromSelectedNode().then(() => path);
    },

    /**
     * 初始化弹窗所属机构：
     * - 新增且已选班级：预填当前班，父级子树内可切换
     * - 新增且已选年级/校区等：从该节点子树继续选班
     * - 编辑：锁定为当前记录班级
     */
    initDeptFormSelection(formType, preselectDeptId) {
      const isAdd = formType === 'add';
      const deptId = preselectDeptId || this.DepartmentId;

      if (isAdd && this.isClassDeptData(this.currentDepartmentData, this.currentDepartmentNode)) {
        return this.loadDeptCascaderForClassSwitch();
      }

      if (!isAdd && deptId) {
        this.deptCascaderLocked = true;
        if (!this.lockedDepartmentName) {
          this.lockedDepartmentName = this.currentDepartmentName || '';
        }
        return this.loadDeptCascaderOptions(deptId).then((path) => {
          if (!path.length) {
            this.deptCascaderLocked = false;
            return [deptId].filter(id => normalizeDeptId(id));
          }
          return path;
        });
      }

      this.deptCascaderLocked = false;
      this.lockedDepartmentName = '';
      if (isAdd && this.currentDepartmentData) {
        return this.loadDeptCascaderFromSelectedNode();
      }
      return this.loadDeptCascaderOptions(deptId);
    },

    onAddDialogClose() {
      this.deptCascaderLocked = false;
    },

    onEditDialogClose() {
      this.deptCascaderLocked = false;
      this.lockedDepartmentName = '';
    },

    /** 级联选择器应使用顶部当前学校 ID，而非左侧选中的班级/年级 ID */
    getSchoolIdForDeptCascader() {
      return resolveActiveSchoolId(this) || '';
    },

    normalizeCascaderPath(path) {
      return sanitizeDeptCascaderIds(path);
    },

    /** 按学校加载部门级联树，并可选回显指定班级路径 */
    loadDeptCascaderOptions(preselectDeptId) {
      const schoolId = this.getSchoolIdForDeptCascader();
      if (!schoolId) {
        this.$message.warning('请先在顶部切换学校！');
        return Promise.reject(new Error('missing school id'));
      }
      return getTeachingDepartmentTree({ pid: schoolId }).then((res) => {
        const treeRoot = res.data && res.data.response;
        this.options = prepareDeptCascaderTree(treeRoot ? [treeRoot] : []);
        this.cascaderKey++;
        const targetId = preselectDeptId || this.DepartmentId;
        if (targetId && this.options.length) {
          const path = this.findPathByDeptId(this.options[0], targetId, []);
          if (path && path.length) {
            return this.normalizeCascaderPath(path);
          }
        }
        return [];
      });
    },

    // 递归查找部门树路径，用于编辑时回显班级级联
    findPathByDeptId(node, deptId, path) {
      if (!node) return null;
      const currentPath = [...path, node.value];
      if (String(node.value) === String(deptId)) {
        return currentPath;
      }
      if (node.children && node.children.length) {
        for (let i = 0; i < node.children.length; i++) {
          const found = this.findPathByDeptId(node.children[i], deptId, currentPath);
          if (found) return found;
        }
      }
      return null;
    },

    /** 节次 option 唯一 key */
    getScheduleOptionKey(period) {
      if (!period) return '';
      const id = period.Id != null ? period.Id : 'noid';
      const classNo = period.ClassNo != null ? period.ClassNo : 'noclass';
      return `${id}-${classNo}`;
    },

    /** 节次下拉值：统一转 number，避免 option 与 v-model 类型不一致 */
    getScheduleOptionValue(period) {
      if (!period) return null;
      const raw = (period.Id !== undefined && period.Id !== null && period.Id !== '')
        ? period.Id
        : period.ClassNo;
      if (raw === undefined || raw === null || raw === '') return null;
      const num = Number(raw);
      return Number.isFinite(num) ? num : raw;
    },

    hasSchedulePeriodSelected(value) {
      return value !== null && value !== undefined && value !== '';
    },

    /** 解析节次选项值 */
    resolveSchedulePeriodId(period) {
      return this.getScheduleOptionValue(period);
    },

    /**
     * 提交前兜底同步节次 Id。
     * 解决：下拉已显示节次/时间已填充，但 SchoolSchedulePeriodId 仍为空导致「请选择节次」。
     * 最后更新：2026-08-10
     */
    ensureSchedulePeriodId(formType) {
      const form = formType === 'add' ? this.addForm : this.editForm;
      if (!form) return false;
      if (this.hasSchedulePeriodSelected(form.SchoolSchedulePeriodId)) {
        const normalized = this.getScheduleOptionValue({ Id: form.SchoolSchedulePeriodId });
        if (this.hasSchedulePeriodSelected(normalized)
          && normalized !== form.SchoolSchedulePeriodId) {
          this.$set(form, 'SchoolSchedulePeriodId', normalized);
        }
        return true;
      }
      let period = this.previewPeriod;
      if (!period && form.ClassNo !== undefined && form.ClassNo !== null && form.ClassNo !== '') {
        period = (this.scheduleList || []).find(s => String(s.ClassNo) === String(form.ClassNo));
      }
      if (!period && form.StartTime && form.EndTime) {
        const start = String(form.StartTime).substr(0, 5);
        const end = String(form.EndTime).substr(0, 5);
        period = (this.scheduleList || []).find((s) => {
          const sStart = String(s.StartTime || s.BeginTime || s.Start || '').substr(0, 5);
          const sEnd = String(s.EndTime || s.StopTime || s.End || '').substr(0, 5);
          return sStart === start && sEnd === end;
        });
      }
      if (!period && this.scheduleList && this.scheduleList.length) {
        period = this.scheduleList[0];
      }
      const periodId = this.resolveSchedulePeriodId(period);
      if (!this.hasSchedulePeriodSelected(periodId)) return false;
      this.$set(form, 'SchoolSchedulePeriodId', periodId);
      this.previewPeriod = period;
      this.onSelectSchedule(formType, periodId);
      return true;
    },

    /** 清除节次字段校验红框 */
    clearSchedulePeriodValidate(formType) {
      const formRef = formType === 'add' ? 'addForm' : 'editForm';
      this.$nextTick(() => {
        const form = this.$refs[formRef];
        if (form && form.clearValidate) {
          form.clearValidate('SchoolSchedulePeriodId');
        }
      });
    },

    /** 新增时切换班级，重置节次相关字段 */
    resetSchedulePeriodForAdd() {
      this.scheduleList = [];
      this.scheduleName = '';
      this.previewPeriod = null;
      this.$set(this.addForm, 'SchoolSchedulePeriodId', null);
      this.addForm.ClassNo = '';
      this.addForm.StartTime = '';
      this.addForm.EndTime = '';
      this.clearSchedulePeriodValidate('add');
    },

    /** 手动选择节次 */
    onSchedulePeriodChange(formType, val) {
      this.onSelectSchedule(formType, val);
      this.clearSchedulePeriodValidate(formType);
    },

    handleEditClassChange(val) {
      const departmentId = Array.isArray(val) ? val[val.length - 1] : val;
      if (departmentId) {
        GetSysCourseByDepartmentId({ departmentId: departmentId }).then(res => {
          this.courseList = res.data.response || [];
          // 清空所有课程选择项和教师
          this.editForm.W1CourseId = null;
          this.editForm.W1CourseId2 = null;
          this.editForm.W1TeacherInfoId = null;
          this.editForm.W1TeacherInfoId2 = null;
          this.editForm.W2CourseId = null;
          this.editForm.W2CourseId2 = null;
          this.editForm.W2TeacherInfoId = null;
          this.editForm.W2TeacherInfoId2 = null;
          this.editForm.W3CourseId = null;
          this.editForm.W3CourseId2 = null;
          this.editForm.W3TeacherInfoId = null;
          this.editForm.W3TeacherInfoId2 = null;
          this.editForm.W4CourseId = null;
          this.editForm.W4CourseId2 = null;
          this.editForm.W4TeacherInfoId = null;
          this.editForm.W4TeacherInfoId2 = null;
          this.editForm.W5CourseId = null;
          this.editForm.W5CourseId2 = null;
          this.editForm.W5TeacherInfoId = null;
          this.editForm.W5TeacherInfoId2 = null;
          this.editForm.W6CourseId = null;
          this.editForm.W6CourseId2 = null;
          this.editForm.W6TeacherInfoId = null;
          this.editForm.W6TeacherInfoId2 = null;
          this.editForm.W7CourseId = null;
          this.editForm.W7CourseId2 = null;
          this.editForm.W7TeacherInfoId = null;
          this.editForm.W7TeacherInfoId2 = null;
          // 清空教师列表
          this.teacherListW1 = [];
          this.teacherListW1_2 = [];
          this.teacherListW2 = [];
          this.teacherListW2_2 = [];
          this.teacherListW3 = [];
          this.teacherListW3_2 = [];
          this.teacherListW4 = [];
          this.teacherListW4_2 = [];
          this.teacherListW5 = [];
          this.teacherListW5_2 = [];
          this.teacherListW6 = [];
          this.teacherListW6_2 = [];
          this.teacherListW7 = [];
          this.teacherListW7_2 = [];
        });
        // 根据班级获取节次信息，自动填充序号、开始/结束时间（编辑场景），并提供下拉选择
        getScheduleByClass({ classId: departmentId, departmentId: departmentId }).then(r => {
          try {
            const resp = r.data && (r.data.response || r.data) || {};
            if (resp && resp.Periods && Array.isArray(resp.Periods)) {
              this.scheduleName = resp.Name || '';
              this.scheduleList = resp.Periods;
            } else {
              const list = Array.isArray(resp) ? resp : (resp && resp.data) || [];
              this.scheduleList = Array.isArray(list) ? list : (list ? [list] : []);
              this.scheduleName = '';
            }
            if (this.scheduleList && this.scheduleList.length > 0) {
              const first = this.scheduleList[0];
              this.previewPeriod = first || null;
              this.$nextTick(() => {
                const periodId = this.resolveSchedulePeriodId(first);
                this.$set(this.editForm, 'SchoolSchedulePeriodId', periodId);
                this.onSelectSchedule('edit', periodId);
                this.clearSchedulePeriodValidate('edit');
              });
            } else {
              this.scheduleList = [];
              this.editForm.SchoolSchedulePeriodId = null;
              this.editForm.ClassNo = '';
              this.editForm.StartTime = '';
              this.editForm.EndTime = '';
              this.previewPeriod = null;
              this.scheduleName = '';
            }
          } catch (e) {
            this.scheduleList = [];
            this.editForm.SchoolSchedulePeriodId = null;
            this.previewPeriod = null;
            this.scheduleName = '';
          }
        }).catch(() => {
          this.scheduleList = [];
          this.editForm.SchoolSchedulePeriodId = null;
          this.editForm.ClassNo = '';
          this.editForm.StartTime = '';
          this.editForm.EndTime = '';
          this.previewPeriod = null;
          this.scheduleName = '';
        });
      } else {
        this.courseList = [];
        // 未选择班级时，清空编辑表单的节次相关字段
        this.scheduleList = [];
        this.editForm.SchoolSchedulePeriodId = null;
        this.editForm.ClassNo = '';
        this.editForm.StartTime = '';
        this.editForm.EndTime = '';
        this.previewPeriod = null;
        this.scheduleName = '';
      }
    },

    treeNodeClick(data, node, component) {
      const nextId = data && data.value;
      // 同节点重复抛出时跳过，避免侧栏默认选中与点击叠成双请求。最后更新：2026-09-16
      if (nextId != null && String(nextId) === String(this.DepartmentId)
        && this.currentDepartmentName === (data && data.label)) {
        return;
      }
      this.DepartmentId = nextId
      this.currentDepartmentName = data.label
      this.currentDepartmentData = data
      this.currentDepartmentNode = node
      this.page = 1;
      // 周次查看只拉周课表；模板编辑才拉模板列表，避免重复请求
      if (this.viewMode === 'week') {
        this.loadSemesterWeeksAndSchedule();
      } else {
        this.handleQuery();
      }
    },

    formatDateYmd(date) {
      const d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    formatWeekOption(w) {
      if (!w) return '';
      const days = w.Days || w.days || [];
      const ymds = days.map(d => this.formatDateYmd(d.Date || d.date)).filter(Boolean).sort();
      const range = ymds.length
        ? ` ${ymds[0].slice(5)}~${ymds[ymds.length - 1].slice(5)}`
        : '';
      const today = this.formatDateYmd(new Date());
      const isCurrent = days.some(d => this.formatDateYmd(d.Date || d.date) === today);
      return `第${w.WeekNumber}周${range}${isCurrent ? '（本周）' : ''}`;
    },
    onViewModeChange(mode) {
      if (mode === 'week') {
        this.loadSemesterWeeksAndSchedule();
      } else {
        this.handleQuery();
      }
    },
    onWeekChange() {
      this.loadWeekSchedule();
    },
    shiftWeek(delta) {
      const idx = this.semesterWeeks.findIndex(w => w.WeekNumber === this.selectedWeekNumber);
      const next = this.semesterWeeks[idx + delta];
      if (!next) return;
      this.selectedWeekNumber = next.WeekNumber;
      this.loadWeekSchedule();
    },
    loadSemesterWeeksAndSchedule() {
      if (!this.DepartmentId) {
        this.semesterWeeks = [];
        this.weekPeriods = [];
        this.weekCellMap = {};
        this.weekDayRules = [];
        return;
      }
      const seq = ++this.weekLoadSeq;
      getSemesterWeeksByClassId({ departmentId: this.DepartmentId }).then(res => {
        if (seq !== this.weekLoadSeq) return;
        const weeks = (res && res.data && res.data.success && Array.isArray(res.data.response))
          ? res.data.response
          : [];
        this.semesterWeeks = weeks;
        const today = this.formatDateYmd(new Date());
        const current = weeks.find(w => {
          const days = w.Days || w.days || [];
          return days.some(d => this.formatDateYmd(d.Date || d.date) === today);
        });
        this.selectedWeekNumber = current ? current.WeekNumber : (weeks[0] && weeks[0].WeekNumber);
        this.loadWeekSchedule(seq);
      }).catch(() => {
        if (seq !== this.weekLoadSeq) return;
        this.semesterWeeks = [];
      });
    },
    loadWeekSchedule(loadSeq) {
      if (!this.DepartmentId || this.selectedWeekNumber == null) return;
      const seq = loadSeq != null ? loadSeq : ++this.weekLoadSeq;
      const week = this.semesterWeeks.find(w => w.WeekNumber === this.selectedWeekNumber);
      const days = (week && (week.Days || week.days)) || [];
      const monday = days[0] ? (days[0].Date || days[0].date) : null;
      const weekDate = monday || this.formatDateYmd(new Date());
      this.listLoading = true;
      getWeekSchedule({ departmentId: this.DepartmentId, weekDate }).then(res => {
        if (seq !== this.weekLoadSeq) return;
        this.listLoading = false;
        const data = (res && res.response) || {};
        const entries = data.Entries || data.entries || [];
        this.weekDayRules = data.DayRules || data.dayRules || [];
        this.weekScheduleEntries = entries;
        const cellMap = {};
        const periodMap = {};
        entries.forEach(e => {
          const classNo = e.ClassNo != null ? e.ClassNo : e.classNo;
          const weekDay = e.WeekDay != null ? e.WeekDay : e.weekDay;
          const key = `${classNo}_${weekDay}`;
          const mark = e.AdjustmentMark || e.adjustmentMark || '';
          let adjLabel = '';
          if (mark) {
            const parts = String(mark).split(':');
            adjLabel = parts[1] || '调课';
          }
          cellMap[key] = {
            courseName: e.CourseName || e.courseName || '',
            teacherName: e.TeacherName || e.teacherName || '',
            adjLabel,
            startTime: e.StartTime || e.startTime || '',
            endTime: e.EndTime || e.endTime || '',
            periodName: e.PeriodName || e.periodName || ''
          };
          if (!periodMap[classNo]) {
            periodMap[classNo] = {
              classNo,
              periodName: e.PeriodName || e.periodName || '',
              startTime: e.StartTime || e.startTime || '',
              endTime: e.EndTime || e.endTime || ''
            };
          }
        });
        this.weekCellMap = cellMap;
        this.weekPeriods = Object.keys(periodMap)
          .map(k => periodMap[k])
          .sort((a, b) => a.classNo - b.classNo);
      }).catch(() => {
        if (seq !== this.weekLoadSeq) return;
        this.listLoading = false;
        this.weekPeriods = [];
        this.weekCellMap = {};
        this.weekDayRules = [];
      });
    },
    getWeekCell(classNo, weekDay) {
      return this.weekCellMap[`${classNo}_${weekDay}`] || null;
    },
    getSelectedWeekStart() {
      const week = this.semesterWeeks.find(w => w.WeekNumber === this.selectedWeekNumber);
      const days = (week && (week.Days || week.days)) || [];
      const first = days[0] ? (days[0].Date || days[0].date) : null;
      return first ? this.formatDateYmd(first) : undefined;
    },
    getSelectedWeekEnd() {
      const week = this.semesterWeeks.find(w => w.WeekNumber === this.selectedWeekNumber);
      const days = (week && (week.Days || week.days)) || [];
      const last = days[6] || days[days.length - 1];
      const end = last ? (last.Date || last.date) : null;
      return end ? this.formatDateYmd(end) : undefined;
    },

    // 处理单元格点击，打开快捷任课编辑
    handleCellClick(period, day) {
      if (!period || !period.Id) {
        this.$message.warning('无效的课程记录');
        return;
      }
      this.openQuickEdit(period, day);
    },

    normalizePeriodRow(row) {
      const form = Object.assign({}, row);
      for (let d = 1; d <= 7; d++) {
        const w = 'W' + d;
        ['CourseId', 'CourseId2', 'TeacherInfoId', 'TeacherInfoId2'].forEach(field => {
          const key = w + field;
          if (form[key] == 0) form[key] = null;
        });
        ['ResourceDepartmentId', 'ResourceDepartmentId2'].forEach(field => {
          const key = w + field;
          if (form[key] == null || form[key] === '' || form[key] == 0 || form[key] === '0') {
            form[key] = null;
          } else {
            // 与下拉 option 统一为字符串，避免 bigint/number 比对失败只显示裸 ID
            form[key] = String(form[key]);
          }
        });
      }
      return form;
    },

    openQuickEdit(period, day) {
      this.quickEditForm = this.normalizePeriodRow(period);
      this.quickEditActiveDay = String(day || 1);
      this.quickEditMainTab = 'teacher';
      this.quickEditMeta = {
        periodName: period.PeriodName || ('第' + period.ClassNo + '节'),
        timeRange: this.formatScheduleTime(period),
        departmentName: period.DepartmentName || '',
      };
      this.quickEditVisible = true;
      this.quickEditLoading = true;
      const deptId = period.DepartmentId || period.Did;
      if (!deptId) {
        this.quickEditLoading = false;
        this.$message.warning('未找到班级信息，无法加载科目');
        return;
      }
      Promise.all([
        GetSysCourseByDepartmentId({ departmentId: deptId }).then(res => {
          this.courseList = res.data.response || [];
          this.clearOrphanCourseSelections();
          this.loadQuickEditTeachersForDay(this.quickEditDayNum);
        }).catch(() => {
          this.courseList = [];
        }),
        this.quickEditShowRoom ? this.loadResourceRoomOptions(deptId) : Promise.resolve(),
      ]).finally(() => {
        if (this.quickEditShowRoom) {
          this.ensureSelectedRoomsInOptions();
        }
        this.quickEditLoading = false;
      });
    },

    /**
     * 加载当前学校下可选共享教室（部门），排除本校节点与本班本身。
     */
    loadResourceRoomOptions(currentClassId) {
      const schoolId = this.getSchoolIdForDeptCascader();
      if (!schoolId) {
        this.resourceRoomOptions = [];
        return Promise.resolve();
      }
      return getTeachingDepartmentTree({ pid: schoolId }).then((res) => {
        const treeRoot = res.data && res.data.response;
        const list = [];
        const walk = (node, parentNames) => {
          if (!node) return;
          const idRaw = node.value != null ? node.value : node.Id;
          const id = idRaw != null && idRaw !== '' ? String(idRaw) : '';
          const name = node.label || node.Name || '';
          const orgType = (node.DeptOrgType || node.deptOrgType || '').toString().toLowerCase();
          const pathNames = name ? parentNames.concat([name]) : parentNames.slice();
          // 可选：非学校/校区/学段/年级节点（教室等部门）；本班排除
          const skipTypes = ['school', 'affiliateschool', 'campus', 'period', 'grade'];
          if (id && name && id !== String(schoolId) && id !== String(currentClassId) && !skipTypes.includes(orgType)) {
            list.push({
              id,
              name,
              label: pathNames.length > 1 ? pathNames.join(' / ') : name,
            });
          }
          const children = node.children || [];
          children.forEach((child) => walk(child, pathNames));
        };
        if (treeRoot) {
          walk(treeRoot, []);
        }
        this.resourceRoomOptions = list;
      }).catch(() => {
        this.resourceRoomOptions = [];
      });
    },

    /**
     * 编辑回显：若已存教室不在候选列表（过滤掉了或仅有名称），补一条选项以便 el-select 显示名称。
     */
    ensureSelectedRoomsInOptions() {
      const form = this.quickEditForm || {};
      const options = this.resourceRoomOptions || [];
      const existIds = new Set(options.map((r) => String(r.id)));
      const pushIfNeeded = (id, name) => {
        if (!id) return;
        const sid = String(id);
        if (existIds.has(sid)) return;
        const label = (name || '').toString().trim() || sid;
        options.push({ id: sid, name: label, label });
        existIds.add(sid);
      };
      for (let d = 1; d <= 7; d++) {
        const w = 'W' + d;
        pushIfNeeded(form[w + 'ResourceDepartmentId'], form[w + 'ResourceDepartmentName']);
        pushIfNeeded(form[w + 'ResourceDepartmentId2'], form[w + 'ResourceDepartmentName2']);
      }
      this.resourceRoomOptions = options.slice();
    },

    /** 选择/清空共享教室（资源部门） */
    onQuickEditRoomChange(day, isDoubleWeek, roomId) {
      const w = 'W' + day;
      const idKey = w + (isDoubleWeek ? 'ResourceDepartmentId2' : 'ResourceDepartmentId');
      const nameKey = w + (isDoubleWeek ? 'ResourceDepartmentName2' : 'ResourceDepartmentName');
      const flagKey = w + (isDoubleWeek ? 'IsSharedRoom2' : 'IsSharedRoom');
      const room = this.resourceRoomOptions.find((r) => String(r.id) === String(roomId));
      if (roomId && room) {
        this.$set(this.quickEditForm, idKey, String(room.id));
        this.$set(this.quickEditForm, nameKey, room.name);
        this.$set(this.quickEditForm, flagKey, true);
      } else {
        this.$set(this.quickEditForm, idKey, null);
        this.$set(this.quickEditForm, nameKey, null);
        this.$set(this.quickEditForm, flagKey, false);
      }
    },

    getTeacherListForDay(day, suffix) {
      const key = 'teacherListW' + day + (suffix || '');
      return this[key] || [];
    },

    loadQuickEditTeachersForDay(day) {
      const deptId = this.quickEditForm.DepartmentId;
      if (!deptId || !day) return;
      const w = 'W' + day;
      const courseId = this.quickEditForm[w + 'CourseId'];
      const courseId2 = this.quickEditForm[w + 'CourseId2'];
      if (courseId) {
        this.getTeachers(deptId, courseId, 'teacherListW' + day);
      } else {
        this['teacherListW' + day] = [];
        this.clearOrphanTeacherSelection('teacherListW' + day);
      }
      if (courseId2) {
        this.getTeachers(deptId, courseId2, 'teacherListW' + day + '_2');
      } else {
        this['teacherListW' + day + '_2'] = [];
        this.clearOrphanTeacherSelection('teacherListW' + day + '_2');
      }
    },

    onQuickEditMainTabClick(tab) {
      if (!this.quickEditShowStudentConfig) return;
      if (tab.name === 'student') {
        this.loadStudentConfigData(this.quickEditDayNum);
      }
    },

    saveQuickEditPanel() {
      if (this.quickEditShowStudentConfig && this.quickEditMainTab === 'student') {
        this.saveStudentConfig();
      } else {
        this.saveQuickEdit();
      }
    },

    onQuickEditCourseChange(day, isDoubleWeekCourse, courseId) {
      const deptId = this.quickEditForm.DepartmentId;
      const w = 'W' + day;
      if (!isDoubleWeekCourse) {
        this.$set(this.quickEditForm, w + 'CourseId', courseId || null);
        this.$set(this.quickEditForm, w + 'CourseId2', courseId || null);
        this.$set(this.quickEditForm, w + 'TeacherInfoId', null);
        this.$set(this.quickEditForm, w + 'TeacherInfoId2', null);
        this.getTeachers(deptId, courseId, 'teacherListW' + day);
        this.getTeachers(deptId, courseId, 'teacherListW' + day + '_2');
      } else {
        this.$set(this.quickEditForm, w + 'CourseId2', courseId || null);
        this.$set(this.quickEditForm, w + 'TeacherInfoId2', null);
        this.getTeachers(deptId, courseId, 'teacherListW' + day + '_2');
      }
    },

    saveQuickEdit() {
      if (!this.quickEditForm || !this.quickEditForm.Id) return;
      this.$confirm('确认保存任课配置吗？', '提示', {}).then(() => {
        this.quickEditSaving = true;
        const para = Object.assign({}, this.quickEditForm);
        editDeptCourse(para).then((res) => {
          this.quickEditSaving = false;
          if (util.isEmt.format(res)) return;
          if (res.data.success) {
            this.$message.success(res.data.msg || '保存成功');
            this.quickEditVisible = false;
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch(() => {
          this.quickEditSaving = false;
        });
      }).catch(() => { });
    },

    loadStudentConfigData(day) {
      const period = this.quickEditForm;
      if (!period || !period.Id) {
        this.$message.warning('无效的课程记录');
        return;
      }

      const deptCourseId = period.Id;
      const departmentId = period.DepartmentId || period.Did;
      const weekDay = day;
      const isDoubleWeek = 0;

      this.studentConfigForm = {
        useFullClass: true,
        selectedStudents: [],
        departmentId: departmentId,
        deptCourseId: deptCourseId,
        weekDay: weekDay,
        isDoubleWeek: isDoubleWeek,
        periodName: period.PeriodName || ('第' + period.ClassNo + '节'),
        courseName: period['W' + day + 'CourseName'] || '未指定',
        teacherName: this.getTeachersDisplay(period, day).join(' / ') || ''
      };

      this.studentList = [];
      this.studentConfigLoading = true;

      getDeptCourseStudentConfig({ deptCourseId, weekDay, isDoubleWeek })
        .then(resConfig => {
          if (resConfig.data && resConfig.data.response) {
            const config = resConfig.data.response;
            this.studentConfigForm.useFullClass = (config.Type === 0);
            this.studentConfigForm.selectedStudents = config.StudentIds || [];
          } else {
            this.studentConfigForm.useFullClass = true;
            this.studentConfigForm.selectedStudents = [];
          }
        })
        .catch(() => {
          this.$message.error('获取课程学生配置失败');
        })
        .finally(() => {
          if (departmentId) {
            GetStudentSelectListByClassId({ departmentId: departmentId })
              .then(resStudent => {
                if (resStudent.data && resStudent.data.response) {
                  this.studentList = resStudent.data.response;
                }
                this.studentConfigLoading = false;
              })
              .catch(() => {
                this.studentConfigLoading = false;
              });
          } else {
            this.studentConfigLoading = false;
          }
        });
    },

    // 保存学生配置
    saveStudentConfig() {
      this.studentConfigLoading = true;
      const form = this.studentConfigForm;
      const saveDto = {
        DeptCourseId: form.deptCourseId,
        WeekDay: form.weekDay,
        IsDoubleWeek: form.isDoubleWeek,
        Type: form.useFullClass ? 0 : 1,
        StudentIds: form.useFullClass ? [] : form.selectedStudents
      };

      saveDeptCourseStudentConfig(saveDto).then(res => {
        this.studentConfigLoading = false;
        if (res.data && res.data.success) {
          this.$message.success('保存成功');
        } else {
          this.$message.error(res.data.msg || '保存失败');
        }
      }).catch(() => {
        this.studentConfigLoading = false;
        this.$message.error('保存失败');
      });
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        if (this.$refs && this.$refs.table && this.$refs.table.clearSelection) {
          try {
            this.$refs.table.clearSelection();
            if (this.$refs.table.toggleRowSelection) this.$refs.table.toggleRowSelection(val, true);
          } catch (e) {
            // ignore if ref methods unavailable
          }
        }
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    // 显示该班级所有调代课记录
    showAllAdjustments() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择具体班级');
        return;
      }
      this.adjRecordPage = 1;
      this.adjRecordVisible = true;
      this.loadAdjRecords(1);
    },
    /** 加载变动记录（服务端分页）。最后更新：2026-08-31 */
    loadAdjRecords(page = this.adjRecordPage) {
      if (!this.DepartmentId) return;
      this.adjRecordLoading = true;
      getAdjustmentList({
        departmentId: this.DepartmentId,
        days: 30,
        page: page,
        pageSize: this.adjRecordPageSize,
        startDate: this.viewMode === 'week' ? this.getSelectedWeekStart() : undefined,
        endDate: this.viewMode === 'week' ? this.getSelectedWeekEnd() : undefined,
      }).then(res => {
        this.adjRecordLoading = false;
        if (res.data.success) {
          const pageData = res.data.response || {};
          const rows = pageData.data || [];
          this.adjRecordPage = pageData.page || page;
          this.adjRecordTotal = pageData.dataCount || 0;
          this.allClassAdjustments = rows.map(item => this.mapAdjustmentRecordItem(item));
        } else {
          this.allClassAdjustments = [];
          this.adjRecordTotal = 0;
          this.$message.error(res.data.msg || '获取变动记录失败');
        }
      }).catch(() => {
        this.adjRecordLoading = false;
        this.allClassAdjustments = [];
        this.adjRecordTotal = 0;
        this.$message.error('接口请求异常');
      });
    },
    mapAdjustmentRecordItem(item) {
      const weekTypeStr = item.IsDoubleWeek === 1 ? ' (双周)' : (item.IsDoubleWeek === 2 ? ' (单周)' : '');
      return {
        date: item.AdjustDate,
        type: item.HandleTypeName,
        handleType: item.HandleType,
        teacher: item.NewTeacherName,
        course: item.NewCourseName,
        newDisplayDate: item.NewAdjustDate,
        newPeriod: `${item.NewDayOfWeekName} 第${item.NewClassNo}节${weekTypeStr}`,
        newTime: item.NewTime,
        originalTeacher: item.OriginalTeacherName,
        originalCourse: item.OriginalCourseName,
        originalDisplayDate: item.OriginalAdjustDate,
        originalPeriod: `${item.OriginalDayOfWeekName} 第${item.OriginalClassNo}节${weekTypeStr}`,
        originalTime: item.OriginalTime,
        periodName: `${item.TargetDayOfWeekName} 第${item.TargetClassNo}节${weekTypeStr}`,
        targetAdjustDate: item.TargetAdjustDate,
      };
    },
    handleAdjRecordPageChange(page) {
      this.adjRecordPage = page;
      this.loadAdjRecords(page);
    },
    handleAdjRecordSizeChange(size) {
      this.adjRecordPageSize = size;
      this.adjRecordPage = 1;
      this.loadAdjRecords(1);
    },
    // 判断单双周设置是否一致（如果一致则不显示单/双周标识）
    isSingleDoubleSame(period, day) {
      if (!period) return false;
      const c1 = period['W' + day + 'CourseId'];
      const c2 = period['W' + day + 'CourseId2'];
      const t1 = period['W' + day + 'TeacherInfoId'];
      const t2 = period['W' + day + 'TeacherInfoId2'];
      // 使用宽松相等以兼容字符串和数字（如 "0" == 0）
      return c1 == c2 && t1 == t2;
    },


    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;
      getDeptCourseListPage(para).then((res) => {
        this.total = res.data.response.dataCount
        this.PageSize = res.data.response.PageSize
        this.users = res.data.response.data
        this.listLoading = false

        // 刷新选中行数据
        if (this.currentRow) {
          const freshRow = this.users.find(u => u.Id === this.currentRow.Id);
          if (freshRow) {
            this.selectCurrentRow(freshRow);
          } else {
            // 如果当前页找不到选中行（可能已被删除或换页），则清空选中
            this.currentRow = null;
            if (this.$refs.table) this.$refs.table.clearSelection();
          }
        }
      });
    },

    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.options = [];
      this.courseList = [];

      // 清空教师列表
      this.teacherListW1 = [];
      this.teacherListW1_2 = [];
      this.teacherListW2 = [];
      this.teacherListW2_2 = [];
      this.teacherListW3 = [];
      this.teacherListW3_2 = [];
      this.teacherListW4 = [];
      this.teacherListW4_2 = [];
      this.teacherListW5 = [];
      this.teacherListW5_2 = [];
      this.teacherListW6 = [];
      this.teacherListW6_2 = [];
      this.teacherListW7 = [];
      this.teacherListW7_2 = [];

      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }

      // 回显表单数据（任教已删时列表姓名为空，勿把孤儿 TeacherInfoId 带进下拉）
      const toCourseId = (id) => (id == 0 || !id ? null : id);
      const toTeacherId = (id, name) => {
        if (id == 0 || !id) return null;
        const n = (name || '').toString().trim();
        if (!n || n === '/' || n === '未指定') return null;
        return id;
      };
      this.editForm = {
        ...row,

        Dids: row.Dids || (row.DepartmentId ? [row.DepartmentId] : []),
        W1CourseId: toCourseId(row.W1CourseId),
        W1CourseId2: toCourseId(row.W1CourseId2),
        W1TeacherInfoId: toTeacherId(row.W1TeacherInfoId, row.W1TeacherName),
        W1TeacherInfoId2: toTeacherId(row.W1TeacherInfoId2, row.W1TeacherName2),
        W2CourseId: toCourseId(row.W2CourseId),
        W2CourseId2: toCourseId(row.W2CourseId2),
        W2TeacherInfoId: toTeacherId(row.W2TeacherInfoId, row.W2TeacherName),
        W2TeacherInfoId2: toTeacherId(row.W2TeacherInfoId2, row.W2TeacherName2),
        W3CourseId: toCourseId(row.W3CourseId),
        W3CourseId2: toCourseId(row.W3CourseId2),
        W3TeacherInfoId: toTeacherId(row.W3TeacherInfoId, row.W3TeacherName),
        W3TeacherInfoId2: toTeacherId(row.W3TeacherInfoId2, row.W3TeacherName2),
        W4CourseId: toCourseId(row.W4CourseId),
        W4CourseId2: toCourseId(row.W4CourseId2),
        W4TeacherInfoId: toTeacherId(row.W4TeacherInfoId, row.W4TeacherName),
        W4TeacherInfoId2: toTeacherId(row.W4TeacherInfoId2, row.W4TeacherName2),
        W5CourseId: toCourseId(row.W5CourseId),
        W5CourseId2: toCourseId(row.W5CourseId2),
        W5TeacherInfoId: toTeacherId(row.W5TeacherInfoId, row.W5TeacherName),
        W5TeacherInfoId2: toTeacherId(row.W5TeacherInfoId2, row.W5TeacherName2),
        W6CourseId: toCourseId(row.W6CourseId),
        W6CourseId2: toCourseId(row.W6CourseId2),
        W6TeacherInfoId: toTeacherId(row.W6TeacherInfoId, row.W6TeacherName),
        W6TeacherInfoId2: toTeacherId(row.W6TeacherInfoId2, row.W6TeacherName2),
        W7CourseId: toCourseId(row.W7CourseId),
        W7CourseId2: toCourseId(row.W7CourseId2),
        W7TeacherInfoId: toTeacherId(row.W7TeacherInfoId, row.W7TeacherName),
        W7TeacherInfoId2: toTeacherId(row.W7TeacherInfoId2, row.W7TeacherName2)
      };

      if (this.editForm.Dids) {
        this.editForm.Dids = sanitizeDeptCascaderIds(this.editForm.Dids);
      } else {
        this.editForm.Dids = [];
      }

      // 按左侧选中机构初始化所属班级，再打开编辑对话框
      this.editDataLoading = true;
      this.options = [];
      this.lockedDepartmentName = row.DepartmentName || this.currentDepartmentName || '';
      this.initDeptFormSelection('edit', row.DepartmentId).then((path) => {
        if (path.length) {
          this.editForm.Dids = path;
        }
        this.editFormVisible = true;
      }).catch(() => {
        this.editDataLoading = false;
      });

      // 加载课程列表
      const departmentId = row.DepartmentId || (
        Array.isArray(this.editForm.Dids)
          ? this.editForm.Dids[this.editForm.Dids.length - 1]
          : this.editForm.Dids
      );
      // 先根据班级加载节次（用于回显编辑时的节次选择）
      if (departmentId) {
        // 使用当前行数据优先回显已保存的节次 id
        const savedPeriodId = row && (row.SchoolSchedulePeriodId || row.ScheduleId) || null;
        getScheduleByClass({ classId: departmentId, departmentId: departmentId }).then(r => {
          try {
            const resp = r.data && (r.data.response || r.data) || {};
            if (resp && resp.Periods && Array.isArray(resp.Periods)) {
              this.scheduleName = resp.Name || '';
              this.scheduleList = resp.Periods;
            } else {
              const list = Array.isArray(resp) ? resp : (resp && resp.data) || [];
              this.scheduleList = Array.isArray(list) ? list : (list ? [list] : []);
              this.scheduleName = '';
            }
            if (this.scheduleList && this.scheduleList.length > 0) {
              // 如果行里有保存的节次，优先回显；否则使用第一条
              const findById = this.scheduleList.find(s => (savedPeriodId && (s.Id === savedPeriodId || s.ClassNo === savedPeriodId)));
              const pick = findById || this.scheduleList[0];
              const periodId = (savedPeriodId && findById)
                ? this.resolveSchedulePeriodId(findById)
                : this.resolveSchedulePeriodId(pick);
              this.$set(this.editForm, 'SchoolSchedulePeriodId', periodId);
              const fmt = t => t ? (typeof t === 'string' && t.length >= 5 ? t.substr(0, 5) : t) : '';
              this.editForm.ClassNo = pick.ClassNo;
              this.editForm.StartTime = fmt(pick.StartTime || pick.BeginTime || pick.Start || '');
              this.editForm.EndTime = fmt(pick.EndTime || pick.StopTime || pick.End || '');
              this.$nextTick(() => this.clearSchedulePeriodValidate('edit'));
            } else {
              this.scheduleList = [];
            }
          } catch (e) {
            this.scheduleList = [];
          }
        }).catch(() => {
          this.scheduleList = [];
        });
      }
      if (departmentId) {
        GetSysCourseByDepartmentId({ departmentId: departmentId }).then(res => {
          this.courseList = res.data.response || [];
          this.clearOrphanCourseSelections();
          // 预加载已选课程对应的教师列表，确保编辑时回显单/双周教师
          const deptId = departmentId;
          const tasks = [];
          const tryLoadTeachers = (courseKey, teacherListKey) => {
            const courseId = this.editForm[courseKey];
            if (courseId) {
              const p = this.getTeachers(deptId, courseId, teacherListKey);
              if (p && p.then) tasks.push(p);
            } else {
              this[teacherListKey] = [];
            }
          };

          tryLoadTeachers('W1CourseId', 'teacherListW1');
          tryLoadTeachers('W1CourseId2', 'teacherListW1_2');
          tryLoadTeachers('W2CourseId', 'teacherListW2');
          tryLoadTeachers('W2CourseId2', 'teacherListW2_2');
          tryLoadTeachers('W3CourseId', 'teacherListW3');
          tryLoadTeachers('W3CourseId2', 'teacherListW3_2');
          tryLoadTeachers('W4CourseId', 'teacherListW4');
          tryLoadTeachers('W4CourseId2', 'teacherListW4_2');
          tryLoadTeachers('W5CourseId', 'teacherListW5');
          tryLoadTeachers('W5CourseId2', 'teacherListW5_2');
          tryLoadTeachers('W6CourseId', 'teacherListW6');
          tryLoadTeachers('W6CourseId2', 'teacherListW6_2');
          tryLoadTeachers('W7CourseId', 'teacherListW7');
          tryLoadTeachers('W7CourseId2', 'teacherListW7_2');

          if (tasks.length === 0) {
            this.editDataLoading = false;
          } else {
            Promise.all(tasks).then(() => {
              this.editDataLoading = false;
            }).catch(() => {
              // 即便部分教师加载失败，也关闭 loading，避免用户长时间等待
              this.editDataLoading = false;
            });
          }
        });
      } else {
        this.courseList = [];
        this.editDataLoading = false;
      }

    },
    //编辑
    editSubmit: function () {
      this.ensureSchedulePeriodId('edit');
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // 如果节次列表为空或未选中节次，阻止提交
          if (!this.scheduleList || this.scheduleList.length === 0) {
            this.$message({ message: '当前班级未配置节次，无法提交', type: 'error' });
            return;
          }
          if (!this.ensureSchedulePeriodId('edit')) {
            this.$message({ message: '请选择节次', type: 'error' });
            return;
          }
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            // 表单字段已使用 SchoolSchedulePeriodId，直接提交即可

            editDeptCourse(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          deleteDeptCourse(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示新增界面
    handleAdd() {
      if (!this.getSchoolIdForDeptCascader()) {
        this.$message.warning('请先在顶部切换学校！');
        return;
      }
      // 限制：必须先在左侧选择机构
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning('请先在左侧选择机构！');
        return;
      }
      this.options = [];
      this.courseList = [];

      // 清空教师列表
      this.teacherListW1 = [];
      this.teacherListW1_2 = [];
      this.teacherListW2 = [];
      this.teacherListW2_2 = [];
      this.teacherListW3 = [];
      this.teacherListW3_2 = [];
      this.teacherListW4 = [];
      this.teacherListW4_2 = [];
      this.teacherListW5 = [];
      this.teacherListW5_2 = [];
      this.teacherListW6 = [];
      this.teacherListW6_2 = [];
      this.teacherListW7 = [];
      this.teacherListW7_2 = [];

      this.addForm = {
        ClassNo: '',        // 课程序号
        StartTime: '',      // 课程开始时间 HH:mm
        EndTime: '',        // 课程结束时间 HH:mm
        W1CourseId: null,   // 周一课程id
        W1CourseId2: null,  // 周一课程id(双周)
        W1TeacherInfoId: null,  // 周一教师id
        W1TeacherInfoId2: null, // 周一教师id(双周)
        W2CourseId: null,   // 周二课程id
        W2CourseId2: null,  // 周二课程id(双周)
        W2TeacherInfoId: null,  // 周二教师id
        W2TeacherInfoId2: null, // 周二教师id(双周)
        W3CourseId: null,   // 周三课程id
        W3CourseId2: null,  // 周三课程id(双周)
        W3TeacherInfoId: null,  // 周三教师id
        W3TeacherInfoId2: null, // 周三教师id(双周)
        W4CourseId: null,   // 周四课程id
        W4CourseId2: null,  // 周四课程id(双周)
        W4TeacherInfoId: null,  // 周四教师id
        W4TeacherInfoId2: null, // 周四教师id(双周)
        W5CourseId: null,   // 周五课程id
        W5CourseId2: null,  // 周五课程id(双周)
        W5TeacherInfoId: null,  // 周五教师id
        W5TeacherInfoId2: null, // 周五教师id(双周)
        W6CourseId: null,   // 周六课程id
        W6CourseId2: null,  // 周六课程id(双周)
        W6TeacherInfoId: null,  // 周六教师id
        W6TeacherInfoId2: null, // 周六教师id(双周)
        W7CourseId: null,   // 周日课程id
        W7CourseId2: null,   // 周日课程id(双周)
        W7TeacherInfoId: null,  // 周日教师id
        W7TeacherInfoId2: null, // 周日教师id(双周)
        EarlyEnterTime: 0,
        Dids: [],
        DepartmentId: 0,
        SchoolSchedulePeriodId: null,
      };
      // 新增对话框打开时应清空节次相关展示和选择
      this.scheduleList = [];
      this.scheduleName = '';
      this.previewPeriod = null;
      this.addForm.ClassNo = '';
      this.addForm.StartTime = '';
      this.addForm.EndTime = '';
      this.deptCascaderLocked = false;
      // 左侧已选班级则直接回填；否则打开级联供选班
      this.initDeptFormSelection('add', this.DepartmentId).then((path) => {
        if (path.length) {
          this.addForm.Dids = path;
        }
        this.addFormVisible = true;
        this.$nextTick(() => {
          const form = this.$refs.addForm;
          if (form && form.clearValidate) form.clearValidate();
          if (path.length) {
            this.handleClassChange(path);
          }
        });
      }).catch(() => {});
    },
    //新增
    addSubmit: function () {
      this.ensureSchedulePeriodId('add');
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 如果节次列表为空或未选中节次，阻止提交
          if (!this.scheduleList || this.scheduleList.length === 0) {
            this.$message({ message: '当前班级未配置节次，无法提交', type: 'error' });
            return;
          }
          if (!this.ensureSchedulePeriodId('add')) {
            this.$message({ message: '请选择节次', type: 'error' });
            return;
          }
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.DepartmentId = para.Dids.pop();
            // 表单字段已使用 SchoolSchedulePeriodId，直接提交即可
            addDeptCourse(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

    /**
     * 一键迁移课表：打开预览弹窗。创建于 2026-09-20
     */
    handleMigrateTimetable() {
      const schoolId = this.getSchoolIdForDeptCascader();
      if (!schoolId) {
        this.$message.warning('请先在顶部切换学校！');
        return;
      }
      this.migrateDialogVisible = true;
      this.migratePreview = null;
      this.migratePage = 1;
      this.migrateFilterKeyword = '';
      this.migrateFilterAction = '';
      this.migrateFilterClassNo = null;
      this.calcMigrateTableHeight();
      this.migratePreviewLoading = true;
      const payload = {
        SchoolId: schoolId,
        ScopeDepartmentId: this.DepartmentId > 0 ? this.DepartmentId : null,
      };
      previewMigrateTimetableToDefaultSchedule(payload).then(res => {
        this.migratePreviewLoading = false;
        const body = res && res.data ? res.data : res;
        if (body && body.success) {
          this.migratePreview = body.response || null;
          this.$nextTick(() => this.calcMigrateTableHeight());
        } else {
          this.migratePreview = null;
          this.$message.error((body && body.msg) || '预览失败');
        }
      }).catch(() => {
        this.migratePreviewLoading = false;
        this.migratePreview = null;
        this.$message.error('预览失败，请稍后重试');
      });
    },

    /** 按视口计算表格高度，保证分页与底部按钮可见。创建于 2026-09-20 */
    calcMigrateTableHeight() {
      if (typeof window === 'undefined') {
        this.migrateTableHeight = 360;
        return;
      }
      // 预留：顶距 + 标题 + 提示摘要 + 筛选 + 分页 + 底部按钮 + 边距
      const reserved = 340;
      const available = Math.floor(window.innerHeight * 0.92 - reserved);
      this.migrateTableHeight = Math.max(180, Math.min(480, available));
    },

    onMigrateDialogOpened() {
      this.calcMigrateTableHeight();
      window.addEventListener('resize', this.calcMigrateTableHeight);
    },

    onMigrateDialogClosed() {
      window.removeEventListener('resize', this.calcMigrateTableHeight);
    },

    /**
     * 导出当前范围班级课表为与导入同格式的矩阵 Excel。
     * 全屏 loading 由全局 exportLoadingMixin 统一负责，勿再手动 $loading。最后更新：2026-11-02
     */
    exportCurrentTimetable() {
      const schoolId = this.getSchoolIdForDeptCascader();
      if (!schoolId) {
        this.$message.warning('请先在顶部切换学校！');
        return;
      }
      return exportTimetableMatrix({
        SchoolId: schoolId,
        ScopeDepartmentId: this.DepartmentId > 0 ? this.DepartmentId : null,
      }).then((res) => {
        const body = res && res.data ? res.data : res;
        if (!(body && body.success)) {
          this.$message.error((body && body.msg) || '导出失败');
          return;
        }
        const rows = body.response || body.Response || [];
        if (!rows.length) {
          this.$message.warning((body && body.msg) || '暂无课表数据可导出');
          return;
        }
        this.writeTimetableMatrixExcel(rows);
        this.$message.success(body.msg || `已导出 ${rows.length} 条节次，改完后可走「导入班级课表」回写`);
      }).catch(() => {
        this.$message.error('导出失败，请稍后重试');
      });
    },

    /**
     * 将 BatchAdd 行写成与导入模板同结构的矩阵 Excel。创建于 2026-09-20
     */
    writeTimetableMatrixExcel(rows) {
      const dayNamesAll = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
      const hasWeekend = rows.some((r) => {
        const w6 = (r.W6CourseName || r.w6CourseName || '').toString().trim();
        const w7 = (r.W7CourseName || r.w7CourseName || '').toString().trim();
        const t6 = (r.W6TeacherName || r.w6TeacherName || r.W6TeacherName2 || r.w6TeacherName2 || '').toString().trim();
        const t7 = (r.W7TeacherName || r.w7TeacherName || r.W7TeacherName2 || r.w7TeacherName2 || '').toString().trim();
        return !!(w6 || w7 || t6 || t7);
      });
      const dayNames = hasWeekend ? dayNamesAll : dayNamesAll.slice(0, 5);
      const maxPeriod = Math.max(1, ...rows.map((r) => Number(r.ClassNo || r.classNo) || 0));

      const tipRows = [
        ['（导出说明：可改格子内课程/教师后，用「导入班级课表」回写；同一班级同一节次会覆盖更新）'],
        ['1. 前两列：校区、班级；校区同名班级请保留校区列，与系统校区名称/简称一致。'],
        ['2. 班级名与系统名称或简称完全一致。'],
        ['3. 格子内第一行课程（可写单周/双周），第二行教师（可写单周/双周）。'],
        ['4. 第 N 节对应作息排序后的第 N 个节次。'],
      ];

      const row1 = ['校区', '班级'];
      const row2 = ['', ''];
      dayNames.forEach((day) => {
        for (let period = 1; period <= maxPeriod; period++) {
          row1.push(period === 1 ? day : '');
          row2.push(`第${period}节`);
        }
      });

      const classMap = {};
      rows.forEach((r) => {
        const campus = (r.CampusName || r.campusName || '').toString().trim();
        const cls = (r.DepartmentName || r.departmentName || '').toString().trim();
        const classNo = Number(r.ClassNo || r.classNo) || 0;
        if (!cls || classNo <= 0) return;
        const key = `${campus}||${cls}`;
        if (!classMap[key]) {
          classMap[key] = { campus, cls, periods: {} };
        }
        classMap[key].periods[classNo] = r;
      });

      const formatCell = (item, day) => {
        if (!item) return '';
        const course = (item[`W${day}CourseName`] || item[`w${day}CourseName`] || '').toString().trim();
        const t1 = (item[`W${day}TeacherName`] || item[`w${day}TeacherName`] || '').toString().trim();
        const t2 = (item[`W${day}TeacherName2`] || item[`w${day}TeacherName2`] || '').toString().trim();
        const teacher = t1 && t2 ? `${t1}/${t2}` : (t1 || t2);
        if (!course && !teacher) return '';
        if (course && teacher) return `${course}\n${teacher}`;
        return course || teacher;
      };

      const dataRows = Object.keys(classMap).sort((a, b) => a.localeCompare(b, 'zh')).map((key) => {
        const g = classMap[key];
        const line = [g.campus, g.cls];
        dayNames.forEach((_, dayIdx) => {
          const day = dayIdx + 1;
          for (let period = 1; period <= maxPeriod; period++) {
            line.push(formatCell(g.periods[period], day));
          }
        });
        return line;
      });

      const aoa = tipRows.concat([row1, row2], dataRows);
      const ws = utils.aoa_to_sheet(aoa);
      const fixedCols = 2;
      const colEnd = fixedCols + dayNames.length * maxPeriod - 1;
      const merges = [];
      for (let r = 0; r < tipRows.length; r++) {
        merges.push({ s: { r, c: 0 }, e: { r, c: colEnd } });
      }
      dayNames.forEach((_, dayIdx) => {
        const startCol = fixedCols + dayIdx * maxPeriod;
        const endCol = startCol + maxPeriod - 1;
        merges.push({ s: { r: tipRows.length, c: startCol }, e: { r: tipRows.length, c: endCol } });
      });
      ws['!merges'] = merges;
      ws['!cols'] = [{ wch: 14 }, { wch: 14 }].concat(Array(dayNames.length * maxPeriod).fill({ wch: 12 }));
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, '班级课表');
      const schoolId = this.getSchoolIdForDeptCascader() || '';
      writeFile(wb, `班级课表导出_${schoolId}_${util.formatDate.format(new Date(), 'yyyyMMddhhmm')}.xlsx`);
    },

    /**
     * 二次确认后执行迁移。创建于 2026-09-20
     */
    confirmMigrateTimetable() {
      const schoolId = this.getSchoolIdForDeptCascader();
      if (!schoolId || !this.migratePreview) return;
      const n = this.migratePreview.UpdatedCount || 0;
      if (n <= 0) {
        this.$message.info('没有需要迁移的课表');
        return;
      }
      const scopeTip = this.currentDepartmentName
        ? `范围：${this.currentDepartmentName}`
        : '范围：整校';
      this.$confirm(
        `将把 ${n} 条课表节次重绑到当前默认作息（按第几节匹配），并覆盖时间。${scopeTip}。此操作不可逆，是否继续？`,
        '确认迁移',
        { type: 'warning', confirmButtonText: '确认迁移', cancelButtonText: '取消' }
      ).then(() => {
        this.migrateSaving = true;
        return migrateTimetableToDefaultSchedule({
          SchoolId: schoolId,
          ScopeDepartmentId: this.DepartmentId > 0 ? this.DepartmentId : null,
        });
      }).then(res => {
        this.migrateSaving = false;
        if (!res) return;
        const body = res && res.data ? res.data : res;
        if (body && body.success) {
          this.migratePreview = body.response || this.migratePreview;
          this.$message.success(body.msg || '迁移完成');
          this.migrateDialogVisible = false;
          if (this.viewMode === 'week') {
            this.loadWeekSchedule();
          } else {
            this.handleQuery();
          }
        } else {
          this.$message.error((body && body.msg) || '迁移失败');
        }
      }).catch(err => {
        this.migrateSaving = false;
        if (err === 'cancel' || (err && err === 'close')) return;
        this.$message.error('迁移失败，请稍后重试');
      });
    },

    // 导入：打开弹窗
    ImportCensus() {
      if (!this.getSchoolIdForDeptCascader()) {
        this.$message.warning('请先在顶部切换学校！')
        return
      }
      this.resetImportDialog()
      this.importDialogVisible = true
    },
    /** 重置导入弹窗状态 */
    resetImportDialog() {
      this.importStep = 1
      this.outputs = []
      this.importSaving = false
      this.importResult = this.emptyImportResult()
      this.importPreviewPage = 1
      this.importPreviewKeyword = ''
      this.importResultTab = 'success'
      this.importResultKeyword = ''
      this.importSuccessPage = 1
      this.importErrorPage = 1
      this.excelInput = false
      this.$nextTick(() => {
        this.excelInput = true
      })
    },
    emptyImportResult() {
      return {
        SuccessCount: 0,
        AddCount: 0,
        UpdateCount: 0,
        FailCount: 0,
        Errors: [],
        SuccessItems: [],
        Message: '',
      }
    },
    /** 导入完成后再次导入 */
    continueImport() {
      this.importStep = 1
      this.outputs = []
      this.importResult = this.emptyImportResult()
      this.importPreviewPage = 1
      this.importPreviewKeyword = ''
      this.importResultTab = 'success'
      this.importResultKeyword = ''
      this.importSuccessPage = 1
      this.importErrorPage = 1
      this.excelInput = false
      this.$nextTick(() => {
        this.excelInput = true
      })
    },
    /** 导入结果 Tab 切换 */
    switchImportResultTab(tab) {
      if (this.importResultTab === tab) return
      this.importResultTab = tab
      this.importResultKeyword = ''
      this.importSuccessPage = 1
      this.importErrorPage = 1
    },
    /** 导入结果搜索 */
    onImportResultKeywordInput() {
      if (this.importResultTab === 'fail') {
        this.importErrorPage = 1
      } else {
        this.importSuccessPage = 1
      }
    },
    /** 导入完成后根据成败默认打开 Tab */
    applyImportResultTab() {
      this.importResultKeyword = ''
      this.importSuccessPage = 1
      this.importErrorPage = 1
      this.importResultTab = (this.importResult.FailCount > 0) ? 'fail' : 'success'
    },
    /** 触发选择文件 */
    triggerImportFile() {
      if (this.$refs.upload) {
        this.$refs.upload.value = ''
        this.$refs.upload.click()
      }
    },
    /** 下载周课表矩阵模板（校区+班级列；单格换行；说明拆多行） */
    downloadImportTemplate() {
      const dayNames = ['周一', '周二', '周三', '周四', '周五']
      const periodCount = 6
      const tipRows = [
        ['（填写说明可删；下方「示例校区」样例行请删除后再导入）'],
        ['1. 前两列：校区、班级；多校区同名班级必须填校区（与系统校区名称或简称一致），单校区可留空校区'],
        ['2. 班级须与系统名称或简称全文一致，如：六年级14班'],
        ['3. 格子内第一行课程（可写单周/双周），第二行教师姓名（可写单周/双周）'],
        ['4. 单双周示例：语文/数学（换行）张三/李四'],
        ['5. 教师须已在系统中，缺任职/任教会自动补'],
        ['6. 第N节对应作息排序后第N个节次'],
      ]
      // 列：校区 | 班级 | 周一第1节…周五第6节
      const row1 = ['校区', '班级']
      const row2 = ['', '']
      dayNames.forEach((day) => {
        for (let p = 1; p <= periodCount; p++) {
          row1.push(p === 1 ? day : '')
          row2.push(`第${p}节`)
        }
      })
      const sample = ['示例校区', '六年级1班']
      dayNames.forEach(() => {
        for (let p = 1; p <= periodCount; p++) {
          // 一个单元格内换行：第一行课程，第二行教师
          sample.push(p === 1 ? '语文/数学\n张三/李四' : '')
        }
      })
      const aoa = tipRows.concat([row1, row2, sample])
      const ws = utils.aoa_to_sheet(aoa)
      const fixedCols = 2 // 校区、班级
      const colEnd = fixedCols + dayNames.length * periodCount - 1
      const tipRowCount = tipRows.length
      const merges = []
      for (let r = 0; r < tipRowCount; r++) {
        merges.push({ s: { r, c: 0 }, e: { r, c: colEnd } })
      }
      dayNames.forEach((_, dayIdx) => {
        const start = fixedCols + dayIdx * periodCount
        const end = start + periodCount - 1
        merges.push({ s: { r: tipRowCount, c: start }, e: { r: tipRowCount, c: end } })
      })
      ws['!merges'] = merges
      ws['!cols'] = [{ wch: 14 }, { wch: 14 }].concat(Array(dayNames.length * periodCount).fill({ wch: 12 }))
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, '班级课表导入')
      writeFile(wb, '班级课表导入模板.xlsx')
      this.$message.success('模板已下载，请按学校课表格式填写后上传')
    },

    /** 预览：课程 / 教师 */
    formatImportDayCell(row, day) {
      const course = this.getImportDayCourse(row, day)
      const teacherText = this.getImportDayTeacher(row, day)
      if (!course && !teacherText) return ''
      if (course && teacherText) return `${course} / ${teacherText}`
      return course || teacherText
    },
    getImportDayCourse(row, day) {
      return ((row && row[`W${day}CourseName`]) || '').toString().trim()
    },
    getImportDayTeacher(row, day) {
      const teacher = ((row && row[`W${day}TeacherName`]) || '').toString().trim()
      const teacher2 = ((row && row[`W${day}TeacherName2`]) || '').toString().trim()
      return teacher2 ? `${teacher || ''}/${teacher2}` : teacher
    },
    onImportPreviewPageSizeChange(size) {
      this.importDetailPageSize = size
      this.importPreviewPage = 1
    },

    //删除预览行
    removeImport(e) {
      const pageIndex = e['$index']
      const absoluteInFiltered = (Math.max(1, this.importPreviewPage || 1) - 1) * (this.importDetailPageSize || 10) + pageIndex
      const target = this.importPreviewFilteredRows[absoluteInFiltered]
      const absoluteIndex = target != null ? this.outputs.indexOf(target) : -1
      if (absoluteIndex < 0) return
      this.$confirm('确定要删除「' + e.row.DepartmentName + '」第' + e.row.ClassNo + '节？').then(() => {
        this.outputs.splice(absoluteIndex, 1)
        const maxPage = Math.max(1, Math.ceil(this.importPreviewFilteredRows.length / (this.importDetailPageSize || 10)))
        if (this.importPreviewPage > maxPage) {
          this.importPreviewPage = maxPage
        }
      })
    },
    importPreviewRowIndex(pageIndex) {
      return (Math.max(1, this.importPreviewPage || 1) - 1) * (this.importDetailPageSize || 10) + pageIndex + 1
    },
    // 保存信息
    SavaImport() {
      if (!this.outputs.length) {
        this.$message.warning('没有可导入的数据')
        return
      }
      const schoolId = this.getSchoolIdForDeptCascader()
      if (!schoolId) {
        this.$message.warning('请先在顶部切换学校！')
        return
      }
      this.importSaving = true
      const loading = this.$loading({
        lock: true,
        text: '校验并导入中',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      batchAddDeptCourse(this.outputs, schoolId)
        .then((res) => {
          loading.close()
          this.importSaving = false
          const raw = (res.data && res.data.response) || null
          // 结构化结果（含校验未通过时带 Errors、SuccessCount=0 的情况）
          if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
            this.importResult = {
              SuccessCount: raw.SuccessCount != null ? raw.SuccessCount : (raw.successCount || 0),
              AddCount: raw.AddCount != null ? raw.AddCount : (raw.addCount || 0),
              UpdateCount: raw.UpdateCount != null ? raw.UpdateCount : (raw.updateCount || 0),
              FailCount: raw.FailCount != null ? raw.FailCount : (raw.failCount || 0),
              Errors: raw.Errors || raw.errors || [],
              SuccessItems: raw.SuccessItems || raw.successItems || [],
              Message: raw.Message || raw.message || (res.data && res.data.msg) || '',
            }
            this.applyImportResultTab()
            this.importStep = 3
            if (this.importResult.SuccessCount > 0) {
              this.handleQuery()
            }
            return
          }
          // 兼容旧版纯字符串返回
          if (res.data && res.data.success) {
            this.importResult = {
              SuccessCount: this.outputs.length,
              AddCount: 0,
              UpdateCount: 0,
              FailCount: 0,
              Errors: [],
              SuccessItems: [],
              Message: typeof raw === 'string' ? raw : (res.data.msg || '导入完成'),
            }
            this.applyImportResultTab()
            this.importStep = 3
            this.handleQuery()
            return
          }
          // 无结构化 response 时：只把「第N行…」类明细计入失败列表，避免把摘要标题算成一条
          const failMsg = (res.data && res.data.msg) || '导入失败'
          const errorLines = failMsg.split(/\n+/).map(s => s.trim()).filter(Boolean)
          const detailLines = errorLines.filter((line) => /^第\s*\d+\s*行/.test(line))
          const errors = detailLines.length ? detailLines : errorLines
          this.importResult = {
            SuccessCount: 0,
            AddCount: 0,
            UpdateCount: 0,
            FailCount: errors.length,
            Errors: errors,
            SuccessItems: [],
            Message: failMsg,
          }
          this.applyImportResultTab()
          this.importStep = 3
        })
        .catch(() => {
          loading.close()
          this.importSaving = false
          this.$message.error('导入失败，请检查网络或稍后重试')
        })
    },
    /** 模板自带样例行（示例校区等），解析时跳过，不当作正式数据 */
    isTemplateSampleRow(campusLabel, classLabel) {
      const campus = (campusLabel || '').toString().trim()
      const cls = (classLabel || '').toString().trim()
      if (!campus && !cls) return false
      if (campus === '示例校区' || campus.startsWith('示例')) return true
      if (cls.startsWith('示例')) return true
      return false
    },
    readExcel(e) {
      const files = e.target.files
      if (!files || files.length <= 0) {
        return false
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$message.error('上传格式不正确,请上传xls或者xlsx格式')
        return false
      }

      const loading = this.$loading({
        lock: true,
        text: '正在读取文件',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const workbook = read(data, { type: 'binary' })
          const wsname = workbook.SheetNames[0]
          const sheet = workbook.Sheets[wsname]
          const aoa = utils.sheet_to_json(sheet, { header: 1, raw: false, defval: '' })
          loading.close()

          let rows = []
          if (this.isMatrixScheduleSheet(aoa)) {
            rows = this.parseMatrixSchedule(aoa)
          } else {
            // 兼容旧扁平模板
            const ws = utils.sheet_to_json(sheet)
            rows = this.reSetKey(ws).filter((row) => {
              const deptName = (row.DepartmentName || '').toString().trim()
              const campusName = (row.CampusName || '').toString().trim()
              if (!deptName || deptName.startsWith('（填写说明')) return false
              if (this.isTemplateSampleRow(campusName, deptName)) return false
              return true
            })
          }

          if (!rows.length) {
            this.$message.warning('未解析到有效数据，请检查是否为「班级 × 星期节次」矩阵课表')
            return
          }
          this.outputs = rows
          this.importPreviewPage = 1
          this.importPreviewKeyword = ''
          this.importStep = 2
          if (this.$refs.upload) {
            this.$refs.upload.value = ''
          }
        } catch (err) {
          console.log(err)
          loading.close()
          this.$message.error('文件读取失败')
          return false
        }
      }
      fileReader.readAsBinaryString(files[0])
    },
    /** 定位矩阵表头行：紧邻两行分别为「周一…」与「第N节」 */
    findMatrixHeaderIndex(aoa) {
      if (!aoa || aoa.length < 3) return -1
      for (let i = 0; i < aoa.length - 1; i++) {
        const r0 = (aoa[i] || []).join('')
        const r1 = (aoa[i + 1] || []).join('')
        if (/周[一二三四五六日天]/.test(r0) && /第\s*\d+\s*节/.test(r1)) {
          return i
        }
      }
      return -1
    },
    /** 是否矩阵课表（表头含周一、下一行含第N节；可前置说明行） */
    isMatrixScheduleSheet(aoa) {
      return this.findMatrixHeaderIndex(aoa) >= 0
    },
    parseDayOfWeek(text) {
      const t = (text || '').toString().trim()
      const map = { 周一: 1, 星期二: 2, 周二: 2, 星期三: 3, 周三: 3, 星期四: 4, 周四: 4, 星期五: 5, 周五: 5, 星期六: 6, 周六: 6, 星期日: 7, 周日: 7, 周天: 7 }
      if (map[t]) return map[t]
      const m = t.match(/周([一二三四五六日天])/)
      if (!m) return 0
      const cn = { 一: 1, 二: 2, 三: 3, 四: 4, 五: 5, 六: 6, 日: 7, 天: 7 }
      return cn[m[1]] || 0
    },
    parsePeriodOrdinal(text) {
      const t = (text || '').toString().trim()
      const m = t.match(/第\s*(\d+)\s*节/)
      if (m) return parseInt(m[1], 10)
      const n = parseInt(t, 10)
      return Number.isFinite(n) && n > 0 ? n : 0
    },
    /** 格子：课程\\n教师（支持「单周/双周」；中间空行会忽略；多行课程名会合并） */
    splitCourseTeacherCell(raw) {
      const text = (raw == null ? '' : String(raw)).replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim()
      if (!text) return { course: '', teacher: '', teacher2: '' }
      const parts = text.split('\n').map((s) => s.trim()).filter(Boolean)
      const splitWeekTeacher = (teacherRaw) => {
        const t = (teacherRaw || '').toString().trim()
        if (!t) return { teacher: '', teacher2: '' }
        const weekParts = t.split('/').map((x) => x.trim())
        if (weekParts.length <= 1) return { teacher: t, teacher2: '' }
        return {
          teacher: weekParts[0] || '',
          teacher2: weekParts[1] || ''
        }
      }
      if (parts.length >= 2) {
        // 最后一行当教师，前面各行合并为课程（兼容中间空行、课程名自动换行）
        const teacherLine = parts[parts.length - 1]
        const courseLine = parts.slice(0, -1).join('')
        const weekTeacher = splitWeekTeacher(teacherLine)
        return { course: courseLine, teacher: weekTeacher.teacher, teacher2: weekTeacher.teacher2 }
      }
      return { course: parts[0] || '', teacher: '', teacher2: '' }
    },
    emptyImportPeriodRow(departmentName, classNo, campusName) {
      return {
        CampusName: campusName || '',
        DepartmentName: departmentName,
        ClassNo: classNo,
        W1CourseName: '', W1TeacherName: '',
        W1TeacherName2: '',
        W2CourseName: '', W2TeacherName: '',
        W2TeacherName2: '',
        W3CourseName: '', W3TeacherName: '',
        W3TeacherName2: '',
        W4CourseName: '', W4TeacherName: '',
        W4TeacherName2: '',
        W5CourseName: '', W5TeacherName: '',
        W5TeacherName2: '',
        W6CourseName: '', W6TeacherName: '',
        W6TeacherName2: '',
        W7CourseName: '', W7TeacherName: '',
        W7TeacherName2: '',
      }
    },
    /**
     * 解析矩阵课表：自动定位「星期 / 第N节」表头，其下为数据行；说明行可放表头上方。
     * 支持两种首列结构：
     * - 新：校区 | 班级 | 周一…（第N节从第3列起）
     * - 旧：班级 | 周一…（第N节从第2列起）
     * ClassNo = Excel 第几节（1起），后端再映射到作息排序后的第 N 个节次。
     */
    parseMatrixSchedule(aoa) {
      const headerIdx = this.findMatrixHeaderIndex(aoa)
      if (headerIdx < 0) return []

      const dayRow = aoa[headerIdx] || []
      const periodRow = aoa[headerIdx + 1] || []
      const colCount = Math.max(dayRow.length, periodRow.length)

      // 找到第一节次所在列，判断是否有校区列
      let periodStartCol = -1
      for (let c = 0; c < colCount; c++) {
        if (this.parsePeriodOrdinal(periodRow[c]) > 0) {
          periodStartCol = c
          break
        }
      }
      if (periodStartCol < 0) return []

      const hasCampusCol = periodStartCol >= 2
      const campusCol = hasCampusCol ? 0 : -1
      const classCol = hasCampusCol ? 1 : 0

      const colMeta = []
      let currentDay = 0
      for (let c = periodStartCol; c < colCount; c++) {
        const dayText = (dayRow[c] || '').toString().trim()
        if (dayText) {
          const d = this.parseDayOfWeek(dayText)
          if (d > 0) currentDay = d
        }
        const period = this.parsePeriodOrdinal(periodRow[c])
        colMeta[c] = { day: currentDay, period }
      }

      const map = {}
      for (let r = headerIdx + 2; r < aoa.length; r++) {
        const row = aoa[r] || []
        const campusLabel = campusCol >= 0 ? (row[campusCol] || '').toString().trim() : ''
        const classLabel = (row[classCol] || '').toString().trim()
        if (!classLabel || classLabel.startsWith('（填写说明') || classLabel === '班级') continue
        if (campusLabel === '校区' || campusLabel.startsWith('（填写说明')) continue
        // 跳过模板自带「示例校区」样例行，避免当正式数据导入
        if (this.isTemplateSampleRow(campusLabel, classLabel)) continue

        for (let c = periodStartCol; c < row.length; c++) {
          const meta = colMeta[c]
          if (!meta || !meta.day || !meta.period) continue
          const cell = row[c]
          if (cell == null || String(cell).trim() === '') continue

          const { course, teacher, teacher2 } = this.splitCourseTeacherCell(cell)
          if (!course && !teacher && !teacher2) continue

          const key = `${campusLabel}||${classLabel}||${meta.period}`
          if (!map[key]) {
            map[key] = this.emptyImportPeriodRow(classLabel, meta.period, campusLabel)
          }
          const item = map[key]
          item[`W${meta.day}CourseName`] = course
          item[`W${meta.day}TeacherName`] = teacher
          item[`W${meta.day}TeacherName2`] = teacher2
        }
      }

      return Object.values(map).sort((a, b) => {
        const c = String(a.CampusName || '').localeCompare(String(b.CampusName || ''), 'zh')
        if (c !== 0) return c
        const n = String(a.DepartmentName).localeCompare(String(b.DepartmentName), 'zh')
        if (n !== 0) return n
        return (a.ClassNo || 0) - (b.ClassNo || 0)
      })
    },
    reSetKey(ws) {
      let temp = []
      ws.forEach((item) => {
        temp.push({
          CampusName: item['关联校区'] || item['校区'] || '',
          DepartmentName: item['班级'] || '',
          ClassNo: item['课程序号'] || item['第几节'] || '',
          W1CourseName: item['周一课程'] || '',
          W1TeacherName: item['周一教师'] || '',
          W1TeacherName2: item['周一双周教师'] || '',
          W2CourseName: item['周二课程'] || '',
          W2TeacherName: item['周二教师'] || '',
          W2TeacherName2: item['周二双周教师'] || '',
          W3CourseName: item['周三课程'] || '',
          W3TeacherName: item['周三教师'] || '',
          W3TeacherName2: item['周三双周教师'] || '',
          W4CourseName: item['周四课程'] || '',
          W4TeacherName: item['周四教师'] || '',
          W4TeacherName2: item['周四双周教师'] || '',
          W5CourseName: item['周五课程'] || '',
          W5TeacherName: item['周五教师'] || '',
          W5TeacherName2: item['周五双周教师'] || '',
          W6CourseName: item['周六课程'] || '',
          W6TeacherName: item['周六教师'] || '',
          W6TeacherName2: item['周六双周教师'] || '',
          W7CourseName: item['周日课程'] || '',
          W7TeacherName: item['周日教师'] || '',
          W7TeacherName2: item['周日双周教师'] || ''
        })
      })
      return temp
    },
    // 获取教师列表的方法
    getTeachers(departmentId, courseId, teacherListKey) {
      if (departmentId && courseId) {
        return getTeachersByDeptAndCourse({ departmentId: departmentId, courseId: courseId }).then(res => {
          this[teacherListKey] = res.data.response || [];
          this.clearOrphanTeacherSelection(teacherListKey);
          return this[teacherListKey];
        }).catch(() => {
          this[teacherListKey] = [];
          this.clearOrphanTeacherSelection(teacherListKey);
          return [];
        });
      } else {
        this[teacherListKey] = [];
        this.clearOrphanTeacherSelection(teacherListKey);
        return Promise.resolve([]);
      }
    },
    /**
     * 任教已删时下拉无对应项，清空表单中的孤儿 TeacherInfoId，避免编辑框显示裸 ID。
     */
    clearOrphanTeacherSelection(teacherListKey) {
      const fieldMap = {
        teacherListW1: 'W1TeacherInfoId',
        teacherListW1_2: 'W1TeacherInfoId2',
        teacherListW2: 'W2TeacherInfoId',
        teacherListW2_2: 'W2TeacherInfoId2',
        teacherListW3: 'W3TeacherInfoId',
        teacherListW3_2: 'W3TeacherInfoId2',
        teacherListW4: 'W4TeacherInfoId',
        teacherListW4_2: 'W4TeacherInfoId2',
        teacherListW5: 'W5TeacherInfoId',
        teacherListW5_2: 'W5TeacherInfoId2',
        teacherListW6: 'W6TeacherInfoId',
        teacherListW6_2: 'W6TeacherInfoId2',
        teacherListW7: 'W7TeacherInfoId',
        teacherListW7_2: 'W7TeacherInfoId2',
      };
      const field = fieldMap[teacherListKey];
      if (!field) return;

      // 不依赖 dialog visible：教师列表可能在弹窗打开前就返回，否则会残留裸 ID
      const forms = [];
      if (this.editForm && this.editForm.Id) forms.push(this.editForm);
      if (this.addFormVisible && this.addForm) forms.push(this.addForm);
      if (this.quickEditForm && this.quickEditForm.Id) forms.push(this.quickEditForm);

      const list = this[teacherListKey] || [];
      forms.forEach((form) => {
        const id = form[field];
        if (id == null || id === '' || id == 0) return;
        if (!list.some((t) => String(t.Id) === String(id))) {
          this.$set(form, field, null);
        }
      });
    },
    /**
     * 科目已删时清空孤儿 CourseId 及同格 TeacherInfoId，避免编辑框显示裸 ID。
     */
    clearOrphanCourseSelections() {
      const courseIds = new Set((this.courseList || []).map(item => String(item.Id)));
      const forms = [];
      if (this.editForm && this.editForm.Id) forms.push(this.editForm);
      if (this.addFormVisible && this.addForm) forms.push(this.addForm);
      if (this.quickEditForm && this.quickEditForm.Id) forms.push(this.quickEditForm);

      forms.forEach((form) => {
        for (let day = 1; day <= 7; day++) {
          ['', '2'].forEach((suffix) => {
            const courseField = `W${day}CourseId${suffix}`;
            const teacherField = `W${day}TeacherInfoId${suffix}`;
            const courseId = form[courseField];
            if (courseId == null || courseId === '' || courseId == 0) return;
            if (!courseIds.has(String(courseId))) {
              this.$set(form, courseField, null);
              this.$set(form, teacherField, null);
            }
          });
        }
      });
    },
    // 生成节次下拉显示文本，合并正常/备用时间并按天列出
    formatScheduleLabel(period) {
      if (!period) return '';
      const name = period.PeriodName || ('第' + (period.ClassNo || '') + '节');
      const dayNames = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
      const normalMap = {};
      const altMap = {};

      const pushToMap = (map, time, dayName) => {
        if (!time) return;
        if (!map[time]) map[time] = [];
        if (dayName && !map[time].includes(dayName)) map[time].push(dayName);
      };

      // 先使用 EffectiveTimes（若有），按 IsUsingAlt 分组
      const ets = Array.isArray(period.EffectiveTimes) ? period.EffectiveTimes : [];
      ets.forEach(t => {
        const time = t.TimeRange || ((t.StartTime || '') + '-' + (t.EndTime || ''));
        const dayName = t.DayName || (t.DayOfWeekNumber ? dayNames[(t.DayOfWeekNumber - 1) % 7] : '');
        if (t.IsUsingAlt) pushToMap(altMap, time, dayName);
        else pushToMap(normalMap, time, dayName);
      });

      // 如果存在 AltDaysMask / AltStartTime / AltEndTime，则以掩码为准补充/覆盖备用时间
      const mask = Number(period.AltDaysMask || 0);
      const altTimeFromFields = (period.AltStartTime && period.AltEndTime) ? (period.AltStartTime + '-' + period.AltEndTime) : null;
      if (mask && altTimeFromFields) {
        for (let d = 1; d <= 7; d++) {
          const bit = (mask >> (d - 1)) & 1;
          if (bit) {
            const dn = dayNames[d - 1];
            // 从 normalMap 中移除该天（如果存在），因为被备用时间覆盖
            Object.keys(normalMap).forEach(k => {
              const idx = normalMap[k].indexOf(dn);
              if (idx > -1) normalMap[k].splice(idx, 1);
              if (normalMap[k].length === 0) delete normalMap[k];
            });
            pushToMap(altMap, altTimeFromFields, dn);
          }
        }
      }

      // 如果没有 EffectiveTimes 且没有掩码备用时间，使用 NormalTime / Start-End 作为主时间
      if (ets.length === 0 && !mask) {
        const base = period.NormalTime || ((period.StartTime || '') + '-' + (period.EndTime || ''));
        if (base) pushToMap(normalMap, base, dayNames.join('/'));
      }

      const fmtGroup = map => Object.keys(map).map(time => `${time} (${map[time].join('/')})`).join(' | ');
      const normalStr = fmtGroup(normalMap);
      const altStr = fmtGroup(altMap);
      const normalBase = period.NormalTime || ((period.StartTime || '') + '-' + (period.EndTime || '') || '').replace(/^-|-$|\s/g, '');
      if (normalStr && altStr) return `${name} — ${normalBase}  ${normalStr}  /  备用: ${altStr}`;
      if (altStr) return `${name} — ${normalBase}  备用: ${altStr}`;
      return `${name} — ${normalBase}`;
    },
    // 从格式化的节次标签中提取时间部分，供表格 tbody 使用
    formatScheduleTime(period) {
      if (!period) return '';
      const label = this.formatScheduleLabel(period) || '';
      // 适配 PeriodName 可能不包含"第x节"的情况，使用分隔符分割
      const parts = label.split(' — ');
      return parts.length > 1 ? parts.slice(1).join(' — ') : label;
    },
    // 选择节次后，把节次信息填入表单
    onSelectSchedule(formType, val) {
      if (!val && val !== 0) return;
      const find = this.scheduleList.find(s => {
        const optVal = this.getScheduleOptionValue(s);
        return optVal === val || String(optVal) === String(val);
      });
      const fmt = t => t ? (typeof t === 'string' && t.length >= 5 ? t.substr(0, 5) : t) : '';
      if (find) {
        if (formType === 'add') {
          this.addForm.ClassNo = find.ClassNo;
          this.addForm.StartTime = fmt(find.StartTime || find.BeginTime || find.Start || '');
          this.addForm.EndTime = fmt(find.EndTime || find.StopTime || find.End || '');
        } else if (formType === 'edit') {
          this.editForm.ClassNo = find.ClassNo;
          this.editForm.StartTime = fmt(find.StartTime || find.BeginTime || find.Start || '');
          this.editForm.EndTime = fmt(find.EndTime || find.StopTime || find.End || '');
        }
      }
    },
  },
  created() {
    // 新增/编辑各自独立规则，校验时回读表单模型，避免 value 与界面不同步
    const makePeriodValidator = (formType) => (rule, value, callback) => {
      const form = formType === 'add' ? this.addForm : this.editForm;
      let current = value;
      if (!this.hasSchedulePeriodSelected(current) && form) {
        current = form.SchoolSchedulePeriodId;
      }
      if (!this.hasSchedulePeriodSelected(current)) {
        this.ensureSchedulePeriodId(formType);
        current = form && form.SchoolSchedulePeriodId;
      }
      if (!this.hasSchedulePeriodSelected(current)) {
        callback(new Error('请选择节次'));
        return;
      }
      callback();
    };
    const didsRule = [
      { type: 'array', required: true, min: 1, message: '请选择所属机构', trigger: 'change' }
    ];
    this.addFormRules = {
      SchoolSchedulePeriodId: [{ validator: makePeriodValidator('add'), trigger: 'change' }],
      Dids: didsRule,
    };
    this.editFormRules = {
      SchoolSchedulePeriodId: [{ validator: makePeriodValidator('edit'), trigger: 'change' }],
      Dids: didsRule.slice(),
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 权限菜单未必配置该按钮：本地注入入口。创建于 2026-09-20
    if (!this.buttonList.some(b => b.Func === 'handleMigrateTimetable')) {
      this.buttonList.push({
        name: '一键迁移课表',
        Func: 'handleMigrateTimetable',
        id: 9901,
        IsHide: false,
        icon: 'el-icon-refresh',
        btnType: 'warning',
      });
    }
    if (!this.buttonList.some(b => b.Func === 'exportCurrentTimetable')) {
      this.buttonList.push({
        name: '导出课表',
        Func: 'exportCurrentTimetable',
        id: 9902,
        IsHide: false,
        icon: 'el-icon-download',
        btnType: 'primary',
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcMigrateTableHeight);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.course-row {
  display: grid;
  column-gap: 8px;
  align-items: center;
  padding: 8px 12px;
  background: #fbfcfd;
  border-radius: 8px;
}

/* 单行布局：label/select 按顺序占据 8 列，避免过长；窄屏下纵向堆叠 */
.course-row> :nth-child(1) {
  grid-column: 1;
}

.course-row> :nth-child(2) {
  grid-column: 2;
}

.course-row> :nth-child(3) {
  grid-column: 3;
}

.course-row> :nth-child(4) {
  grid-column: 4;
}

.course-row> :nth-child(5) {
  grid-column: 5;
}

.timetable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  min-width: 840px;
}

.course-row> :nth-child(6) {
  grid-column: 6;
}

.course-row> :nth-child(7) {
  grid-column: 7;
}

.course-row> :nth-child(8) {
  grid-column: 8;
}

.course-label {
  color: #606266;
  font-size: 13px;
  text-align: right;
  padding-right: 8px;
}

.course-select {
  min-width: 70px;
  max-width: 100px;
}

.teacher-select {
  min-width: 80px;
  max-width: 120px;
}

@media (max-width: 600px) {
  .course-row {
    grid-template-columns: 90px 1fr;
    grid-template-rows: repeat(4, auto);
  }

  .course-row> :nth-child(1) {
    grid-column: 1;
    grid-row: 1;
  }

  .course-row> :nth-child(2) {
    grid-column: 2;
    grid-row: 1;
  }

  .course-row> :nth-child(3) {
    grid-column: 1;
    grid-row: 2;
  }

  .course-row> :nth-child(4) {
    grid-column: 2;
    grid-row: 2;
  }

  .course-row> :nth-child(5) {
    grid-column: 1;
    grid-row: 3;
  }

  .course-row> :nth-child(6) {
    grid-column: 2;
    grid-row: 3;
  }

  .course-row> :nth-child(7) {
    grid-column: 1;
    grid-row: 4;
  }

  .course-row> :nth-child(8) {
    grid-column: 2;
    grid-row: 4;
  }
}

/* 进一步压缩 el-select 显示，启用单行省略号 */
.course-row .el-select,
.course-row .el-input,
.course-row .el-input__inner {
  font-size: 13px;
}

.course-row .el-select .el-input__inner {
  height: 32px;
  padding: 4px 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-dialog__body {
  padding: 10px 24px !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

/* timetable 样式精简版 */
.timetable-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 5px;
}

.timetable-card {
  background: #fff;
  border: 1px solid #ebeef5;
  /* 回归简单边框 */
  border-radius: 4px;
  padding: 0;
}

.timetable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  min-width: 1000px;
}

.timetable th,
.timetable td {
  border: 1px solid #ebeef5;
  padding: 8px 4px;
  /* 减小内边距 */
  text-align: center;
  vertical-align: middle;
}

.timetable thead th {
  background: #f5f7fa;
  color: #606266;
  font-weight: bold;
  padding: 12px 8px;
  font-size: 14px;
}

.timetable tbody tr:hover td {
  background-color: #fafafa;
}

.period-head {
  width: 120px;
  background-color: #f9fafc;
  color: #606266;
  font-size: 13px;
}

.period-cell {
  background-color: #f9fafc;
}

.period-cell .time {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
}

/* 单元格内容垂直居中 */
.cell-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60px;
  width: 100%;
}

/* 班级课表变动记录弹窗。最后更新：2026-08-31 */
.adj-record-list {
  max-height: 460px;
  overflow-y: auto;
  padding-right: 4px;
}

.adj-record-empty {
  text-align: center;
  padding: 30px;
  color: #909399;
}

.adj-record-pager {
  margin-top: 12px;
  text-align: right;
}

.adj-record-pager .el-pagination {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  row-gap: 6px;
}

/* 1. 代调课层：扁平化设计 */
.adjustment-layer {
  width: 100%;
  margin-bottom: 6px;
  position: relative;
}

.adjustment-card-modern {
  background: transparent;
  /* 去除卡片背景 */
  padding: 0;
  border: none;
  box-shadow: none;
  text-align: center;
}

.card-head {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
  font-size: 12px;
  line-height: 1;
}

/* 类型标签：纯文字加颜色，不去框 */
.card-head .tag {
  font-weight: bold;
}

.type-sub .card-head .tag {
  color: #F56C6C;
}

/* 代课红 */
.type-adj .card-head .tag {
  color: #E6A23C;
}

/* 调课橙 */

.card-head .date {
  color: #909399;
  font-size: 12px;
  transform: scale(0.9);
}

.card-head .week-tag {
  background: #f4f4f5;
  color: #909399;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 2px;
  transform: scale(0.85);
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.4;
}

/* 代调课后的课程名：加粗高亮 */
.card-body .course {
  font-size: 14px;
  font-weight: bold;
  color: #F56C6C;
}

/* 代调课后的老师：高亮 */
.card-body .teacher {
  font-size: 12px;
  color: #F56C6C;
}

/* 更多指示器：极简小加号 */
.more-indicator {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(20%, -20%);
}

.more-indicator span {
  display: inline-block;
  background: #F56C6C;
  color: #fff;
  font-size: 10px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
}

/* 2. 原课程层：被替换样式 */
.original-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.original-info .sep {
  padding: 0 2px;
  color: #C0C4CC;
}

/* 局部删除线样式 */
.is-struck {
  text-decoration: line-through;
  color: #C0C4CC !important;
  font-weight: normal;
}

.course-name {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  line-height: 1.4;
}

.teacher-name {
  color: #606266;
  font-size: 12px;
  line-height: 1.4;
}

.room-name {
  color: #909399;
  font-size: 12px;
  transform: scale(0.9);
}

.select-cell {
  width: 40px;
}

/* Mobile Tweaks */
@media (max-width: 600px) {

  .timetable th,
  .timetable td {
    display: block;
    width: 100%;
    text-align: left;
    border: none;
    border-bottom: 1px solid #ebeef5;
    padding: 10px;
  }

  .timetable thead {
    display: none;
  }

  .cell-content {
    align-items: flex-start;
  }

  .adjustment-card-modern,
  .card-head,
  .card-body {
    align-items: flex-start;
    text-align: left;
  }

  .card-head {
    justify-content: flex-start;
  }

  .original-info {
    align-items: flex-start;
  }
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

/* Config Dialog */
.student-config-dialog .el-dialog__body {
  padding: 20px !important;
}

.student-config-dialog .el-transfer-panel {
  width: 250px;
}

.student-config-dialog .el-transfer-panel__body {
  height: 350px;
}

.student-config-dialog .el-transfer-panel__list.is-filterable {
  height: 290px;
}

.qe-body {
  min-height: 120px;
}

.qe-header {
  margin: 0 0 10px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.qe-header-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.qe-period-tag {
  font-weight: 600;
  border-radius: 6px;
}

.qe-time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #475569;
}

.qe-time i {
  color: #94a3b8;
}

.qe-class-path {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #e2e8f0;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.qe-class-path i {
  margin-top: 2px;
  color: #94a3b8;
  flex-shrink: 0;
}

.qe-tabs /deep/ .el-tabs__header {
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 2px 8px 0;
}

.qe-tabs--single /deep/ .el-tabs__header {
  display: none;
}

.qe-tabs--single /deep/ .el-tabs__content {
  padding-top: 0;
}

.qe-tabs /deep/ .el-tabs__nav-wrap::after {
  display: none;
}

.qe-tabs /deep/ .el-tabs__item {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #64748b;
  transition: color 0.2s ease;
}

.qe-tabs /deep/ .el-tabs__item.is-active {
  color: #0369a1;
  font-weight: 600;
}

.qe-tabs /deep/ .el-tabs__active-bar {
  background-color: #0369a1;
  height: 3px;
  border-radius: 3px 3px 0 0;
}

.qe-tabs /deep/ .el-tabs__content {
  padding-bottom: 4px;
}

.qe-week-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.qe-week-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px 4px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.qe-week-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.qe-week-card--alt {
  border-color: #fde68a;
  background: linear-gradient(180deg, #fffbeb 0%, #fff 40%);
}

.qe-week-card--alt:hover {
  border-color: #fcd34d;
}

.qe-week-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.qe-week-card__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 700;
}

.qe-week-card__badge--alt {
  background: #fef3c7;
  color: #b45309;
}

.qe-week-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.qe-form /deep/ .el-form-item {
  margin-bottom: 10px;
}

.qe-form /deep/ .el-form-item__label {
  color: #64748b;
  font-weight: 500;
}

.qe-field {
  width: 100%;
}

.qe-student-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.qe-student-summary__item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.qe-student-summary__label {
  font-size: 12px;
  color: #94a3b8;
}

.qe-student-summary__value {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.qe-radio-group /deep/ .el-radio {
  margin-right: 20px;
}

.qe-transfer-block {
  margin-top: 4px;
  padding: 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.qe-transfer-tip {
  margin: 0 0 12px;
  font-size: 13px;
  color: #64748b;
}

.qe-transfer-wrap {
  display: flex;
  justify-content: center;
}

.qe-footer {
  text-align: right;
}

@media (max-width: 640px) {
  .qe-week-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<!-- append-to-body 弹窗需全局样式 -->
<style>
.quick-edit-dialog.el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.quick-edit-dialog .el-dialog__header {
  padding: 12px 20px 8px;
  border-bottom: 1px solid #ebeef5;
}

.quick-edit-dialog .el-dialog__title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.4;
}

.quick-edit-dialog .el-dialog__body {
  padding: 10px 20px 6px !important;
  background: #f8fafc;
}

.quick-edit-dialog .el-dialog__footer {
  padding: 10px 20px 14px;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.quick-edit-dialog .el-transfer-panel {
  width: 240px;
  border-radius: 8px;
}

.quick-edit-dialog .el-transfer-panel__body {
  height: 320px;
}

.quick-edit-dialog .el-transfer-panel__list.is-filterable {
  height: 268px;
}

@media (max-width: 640px) {
  .quick-edit-dialog .el-transfer-panel {
    width: 200px;
  }
}

/* 一键迁移课表弹窗。创建于 2026-09-20 */
.migrate-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 18px;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}
.migrate-summary em {
  font-style: normal;
  font-weight: 600;
  color: #303133;
  margin: 0 2px;
}
.migrate-summary em.is-update {
  color: #e6a23c;
}
.migrate-summary em.is-fail {
  color: #f56c6c;
}
.migrate-filters {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
.migrate-empty {
  margin: 24px 0;
  text-align: center;
  color: #909399;
}
.migrate-pagination {
  margin: 0 0 10px;
  text-align: right;
}
.migrate-dialog-footer {
  text-align: right;
}
.migrate-dialog-actions {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

/* 班级课表导入弹窗 */
.dept-course-import-steps {
  margin-bottom: 16px;
}
.dept-course-import-step {
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}
.dept-course-import-step--setup {
  min-height: 0;
}
.dept-course-import-panel {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.dept-course-import-panel__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
  padding: 12px 14px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}
.dept-course-import-panel__meta {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  max-width: 100%;
}
.dept-course-import-panel__title {
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}
.dept-course-import-panel__count {
  flex: 0 0 auto;
  display: inline-block;
  white-space: nowrap;
  padding: 1px 8px;
  border-radius: 10px;
  background: #ecf5ff;
  color: var(--btn-primary, #2563eb);
  font-size: 12px;
  line-height: 1.6;
}
.dept-course-import-panel__count.is-filter {
  background: #fdf6ec;
  color: #e6a23c;
}
.dept-course-import-panel__tip {
  margin: 0;
  padding: 8px 14px 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
.dept-course-import-panel__body {
  padding: 10px 14px 12px;
  overflow-x: auto;
}
.dept-course-import-panel__foot {
  padding: 8px 14px 10px;
  border-top: 1px solid #ebeef5;
  background: #fafbfc;
}
.dept-course-import-search {
  flex: 0 0 220px;
  width: 220px;
}
.dept-course-import-table {
  width: 100%;
}
.dept-course-import-table ::v-deep th {
  background: #f5f7fa !important;
  color: #606266;
  font-weight: 600;
}
.dept-course-import-table ::v-deep td,
.dept-course-import-table ::v-deep th {
  padding: 8px 8px;
}
.dept-course-import-day {
  line-height: 1.4;
  word-break: break-all;
}
.dept-course-import-day__course {
  color: #303133;
  font-weight: 600;
}
.dept-course-import-day__teacher {
  margin-top: 2px;
  color: #606266;
  font-size: 12px;
}
.dept-course-import-pager {
  text-align: right;
}
.dept-course-import-guide {
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #fef0f0;
  border-radius: 6px;
  border: 1px solid #fde2e2;
  border-left: 3px solid #f56c6c;
}
.dept-course-import-guide__title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #f56c6c;
}
.dept-course-import-guide .dept-course-import-tips {
  color: #606266;
}
.dept-course-import-guide .is-important {
  color: #f56c6c;
  font-weight: 600;
}
.dept-course-import-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.dept-course-import-action {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin: 0;
  padding: 16px 16px 14px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.dept-course-import-action:hover {
  border-color: var(--btn-primary, #2563eb);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.12);
}
.dept-course-import-action > i {
  font-size: 22px;
  color: var(--btn-primary, #2563eb);
  margin-bottom: 4px;
}
.dept-course-import-action__title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.dept-course-import-action__desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.dept-course-import-tips {
  margin: 0;
  padding: 0 0 0 18px;
  list-style: disc;
  color: #606266;
  font-size: 13px;
  line-height: 1.7;
}
.dept-course-import-tips li + li {
  margin-top: 4px;
}
.dept-course-import-summary {
  margin: 0 0 12px;
  color: #606266;
  font-size: 14px;
}
.dept-course-import-summary em {
  font-style: normal;
  font-weight: 600;
  color: #303133;
}
.dept-course-import-remove {
  color: #f56c6c !important;
  padding: 0 !important;
}
.dept-course-import-pager {
  margin-top: 10px;
  text-align: right;
}
.dept-course-import-panel__foot .dept-course-import-pager {
  margin-top: 0;
}
.dept-course-import-result {
  text-align: center;
  margin-bottom: 12px;
}
.dept-course-import-result-icon {
  font-size: 32px;
}
.dept-course-import-result-title {
  margin: 6px 0 2px;
  font-size: 14px;
  color: #606266;
}
.dept-course-import-result-title em {
  font-style: normal;
  font-weight: 600;
}
.dept-course-import-result-title em.is-success {
  color: #67c23a;
}
.dept-course-import-result-title em.is-fail {
  color: #f56c6c;
}
.dept-course-import-result-sub {
  color: #909399;
}
.dept-course-import-result-msg {
  margin: 0;
  color: #909399;
  font-size: 12px;
}
.dept-course-import-seg {
  display: inline-flex;
  flex: 0 0 auto;
  padding: 2px;
  border-radius: 6px;
  background: #eef0f3;
}
.dept-course-import-seg__btn {
  margin: 0;
  padding: 5px 14px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #606266;
  font-size: 13px;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
}
.dept-course-import-seg__btn em {
  font-style: normal;
  font-weight: 600;
  margin-left: 2px;
}
.dept-course-import-seg__btn.is-active {
  background: #fff;
  color: var(--btn-primary, #2563eb);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}
.dept-course-import-seg__btn.is-fail.is-active {
  color: #f56c6c;
}
.dept-course-import-table .is-add {
  color: #67c23a;
}
.dept-course-import-table .is-update {
  color: var(--btn-primary, #2563eb);
}
.day-rule-tag {
  margin-top: 2px;
  font-size: 11px;
  color: #e6a23c;
  font-weight: 500;
}
.today-col {
  background: #f0f7ff;
}
.rest-col {
  background: #fafafa;
}
.rest-text {
  color: #909399;
  font-size: 12px;
  text-align: center;
}
.adj-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 0 4px;
  font-size: 11px;
  color: #fff;
  background: #e6a23c;
  border-radius: 2px;
}
</style>

<style>
/* append-to-body 弹窗外层不受 scoped 影响 */
.dept-course-import-dialog .el-dialog__body {
  padding: 12px 20px 8px;
}
.dept-course-import-dialog .dept-course-import-search.el-input {
  width: 220px;
  max-width: 100%;
  flex: 0 0 220px;
}
.dept-course-import-dialog .dept-course-import-panel__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
}
.dept-course-import-dialog .dept-course-import-panel__meta {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}
.dept-course-import-dialog .dept-course-import-panel__title,
.dept-course-import-dialog .dept-course-import-panel__count {
  white-space: nowrap;
  flex-shrink: 0;
}
.dept-course-import-dialog .dept-course-import-seg {
  display: inline-flex;
  flex: 0 0 auto;
}

/* 迁移弹窗：限制在视口内，footer（分页+按钮）始终可见。创建于 2026-09-20 */
.dept-course-migrate-dialog {
  margin-top: 4vh !important;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}
.dept-course-migrate-dialog .el-dialog__body {
  flex: 1 1 auto;
  overflow: hidden;
  padding-bottom: 8px;
}
.dept-course-migrate-dialog .el-dialog__footer {
  flex: 0 0 auto;
  padding-top: 8px;
}
</style>
